import { AfterViewInit, Component, Injectable, OnInit } from '@angular/core';
import { jsPDF } from 'jspdf'
import autoTable, { Cell, CellHookData, MarginPadding, MarginPaddingInput } from 'jspdf-autotable'
import { TemplateService } from 'src/app/services/template.service';
import { InvoiceItemModel, InvoiceTemplateModel, ScenerySAT } from '../models/invoice-template.model';
import { ResponseObject } from '../models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { worksans } from './customFonts'
import { FontService } from '../services/font.service';
import { InvoiceType } from '../enums/invoice-type.enum';
import { ConfigurationMarginPage, ConfigurationPage } from '../models/template.model';

@Injectable({
	providedIn: 'root',
})
export class TemplateInvoice {
	quotationMessage = "Con mucho gusto le presentamos nuestra oferta de acuerdo a su amable solicitud, contáctenos para poder servirle";
	quotationValidity = 'Vigencia 3 días a partir de la fecha emitida.';
	fcolor = "#563d7c";
	scolor = "#C8B7E1";
	tcolor = "#ecebf4";
	company: any;
	warehouses = [];
	template = 1;
	template4text: string = "";
	isLoading: { [key: number]: boolean } = {};
	templateSvgs = [];
	testSvg = null;
	isInvoice = true;
	preview = "";
	isPDFGenerated = true;
	visor = null;
	nunitoBold = "";
	nunitoNormal = "";
	fontAwesome = "";
	dataUrl = null;
	fontSizeTHead = 9;
	fontSizeTBody = 9;
	titlesIn = ['DOCUMENTO ELECTRONICO', 'FACTURA ELECTRONICA', 'COTIZACIÓN', 'ORDEN DE COMPRA', 'TRASLADO', 'REALIZACIÓN DE INVENTARIO', 'NOTA DE CRÉDITO ELECTRONICA', 'FACTURA ELECTRONICA CAMBIARIA', 'ANTICIPO'];

	constructor(
		private templateService: TemplateService,
		private toastService: ToastrService,
		private datePipe: DatePipe,
		private fontService: FontService
	) {
		fontService.getFontAsBinary("assets/fonts/Nunito-Bold.ttf").subscribe(
			(fontData: string) => {
				this.nunitoBold = fontData;
			},
			error => {
				console.error('Error fetching font:', error);
			}
		);
		fontService.getFontAsBinary("assets/fonts/Nunito-Light.ttf").subscribe(
			(fontData: string) => {
				this.nunitoNormal = fontData;
			},
			error => {
				console.error('Error fetching font:', error);
			}
		);
	}


	getContrastColor(hexColor: string): string {
		// Convertir el código hexadecimal a valores RGB
		const r = parseInt(hexColor.slice(1, 3), 16);
		const g = parseInt(hexColor.slice(3, 5), 16);
		const b = parseInt(hexColor.slice(5, 7), 16);

		// Calcular el brillo relativo del color (Luminance)
		const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

		// Determinar si el color de fondo es oscuro o claro y devolver un color de contraste adecuado
		return luminance > 0.5 ? '#000000' : '#ffffff';
	}

	hideElements(hides: any) {
		for (let i = 0; i < hides.length; i++) {
			const element = hides[i];
			element.innerHTML = "";
		}
	}

	changeColorType(type: string, color: any, element: any) {
		var colors = element.getElementsByClassName(type + "-color");
		var colors_circle = element.getElementsByClassName(type + '-color-circle');
		for (let i = 0; i < colors.length; i++) {
			const element = colors[i] as any;
			element.style.fill = color;
			element.style.color = color;
		}
		for (let i = 0; i < colors_circle.length; i++) {
			const element = colors_circle[i] as any;
			element.style.stroke = color;
		}
	}

	showText(element) {
		var fonts = element.querySelectorAll('tspan');
		fonts.forEach((font) => {
			font.style.fontFamily = "'Nunito',sans-serif";
		})
		var text = [];
		if (this.isInvoice) {
			text = element.getElementsByClassName("invoice");
		} else {
			text = element.getElementsByClassName("order");
		}
		if (text.length != 0) {
			text[0].style.display = "inline";
		}
	}

	processSvgAndAddToDoc(svgElement: any, doc: any, template) {
		return new Promise<any>((resolve) => {
			let withoutHide = svgElement.cloneNode(true);
			this.hideElements(withoutHide.getElementsByClassName("hide"));
			this.changeColorType('primary', this.fcolor, withoutHide);
			this.changeColorType('secondary', this.scolor, withoutHide);
			this.changeColorType('tertiary', this.tcolor, withoutHide);
			if (template == 4) {
				console.log(withoutHide.getElementById('title1') as any);
			}
			this.showText(withoutHide);
			let { width, height } = svgElement.getBBox();
			width = doc.internal.pageSize.width * 4;
			height = doc.internal.pageSize.height * 4;
			let clonedSvgElement = withoutHide.cloneNode(true);
			let outerHTML = clonedSvgElement.outerHTML,
				blob = new Blob([outerHTML], { type: 'image/svg+xml;charset=utf-8' });
			let URL: any = window.URL || window.webkitURL || window;
			let blobURL = URL.createObjectURL(blob) as any;
			let image = new Image();
			image.onload = () => {
				let canvas = document.createElement('canvas');
				canvas.width = width;
				canvas.height = height;
				let context = canvas.getContext('2d');
				context.translate(0.5, 0.5);
				context.drawImage(image, -2, -2, width, height);
				const img = canvas.toDataURL('image/jpeg');
				doc.addImage(
					img,
					'JPEG',
					0,
					0,
					doc.internal.pageSize.width + 1,
					doc.internal.pageSize.height + 1,
					'NONE'
				);
				// Resolvemos la promesa cuando la manipulación de la imagen ha terminado
				resolve(img);
			};

			image.src = blobURL;
		});
	}

	async getSVG(templateId: string): Promise<void> {
		try {
			const svgDocument = await this.templateService.getSvg(templateId).toPromise();
			const svgElement = svgDocument.documentElement;
			this.testSvg = svgElement;
			// Puedes realizar manipulaciones en this.svgContent según sea necesario.
			// Por ejemplo, cambiar colores, agregar clases, etc.
		} catch (error) {
			console.error('Error cargando el archivo SVG', error);
		}
	}

	dataDefault(rows = 5) {
		var templateGenerated = new InvoiceTemplateModel();
		templateGenerated.carrier.name = "Fernando José Cascales Morenos";
		templateGenerated.carrier.destination = "Bodega Centro Sur";
		templateGenerated.carrier.nit = "98989898";
		templateGenerated.carrier.plate = "ABCD123";
		templateGenerated.carrier.date = "2024-02-21";
		templateGenerated.client.name = 'Pablo Diego José Francisco de Paula';
		templateGenerated.client.nit = '99999999999999';
		templateGenerated.client.address = 'BARRIO EL CEMENTERIO LOTE 5 CENTRO URBANO SECTOR A, FRAY';
		templateGenerated.certifier.signature = 'Número de autorización: D18C068E-22DD-22EE-22BB-C351615FA8E7';
		templateGenerated.certifier.date = "21/02/2024 10:52:17";
		templateGenerated.certifier.nit = "22222222";
		templateGenerated.certifier.data = "Inforum Consulting, S.A.";
		templateGenerated.invoice.date = "2024-02-21";
		templateGenerated.invoice.number = "NUMERO";
		templateGenerated.invoice.serial = "SERIE";
		templateGenerated.seller.name = 'Inversiones Intelectuales, Sociedad Anónima haciendo mas grande el nombre para ver';
		templateGenerated.seller.city = "Quetzaltenango";
		templateGenerated.seller.nit = "55555555";
		templateGenerated.seller.state = 'Central';
		templateGenerated.inventory.name = "Crespo Fernado Dominguez Chavez";
		templateGenerated.inventory.date = "2024-02-21";
		templateGenerated.inventory.warehouse = "Central";
		templateGenerated['warehouse'] = { name: 'UNA BODEGA CON NOMBRE GIGANTESCO PARA VER COMO ACTUA EL CAMPO QUE COLOQUE', number: '78745523 adsfasdf asdfasdfs' };
		templateGenerated.warehouse.address = "1ra Avenida D-14 Zona 1, Quetzaltenango";
		templateGenerated.setPhrase(new ScenerySAT(0, 0));
		var total_control = 0;
		for (let i = 0; i < rows; i++) {
			var randomQuantity = Math.floor((Math.random() * 10)) + 10;
			var randomPrice = (Math.random() * 100) + 100;
			var randomProducts = ['POCO X5 PRO 5G 18902231 50 MEGAPIXELES', 'CINTA TEMFLEX NEGRO 18.3m  #1711 #165 3M SKU XA012058310 / UU009472471', 'HP ENVY 360 18" INTEL CORE I7', 'HEADPHONES PRIMUS 892 ESPARTAN BLUE SORRUND', 'SMARTWATCH GALAXY WEAROS 90 BLUE PRO'];
			var randomProduct = randomProducts[Math.floor(Math.random() * randomProducts.length)];
			var toAdd = new InvoiceItemModel(randomQuantity, randomPrice, randomProduct);
			toAdd.code = "ABCD123"
			templateGenerated.items.push(
				toAdd
			);
			total_control += randomQuantity * randomPrice;
		}
		templateGenerated.total = total_control;
		return templateGenerated;
	}

	selectTemplate(templateData: any, invoiceData: InvoiceTemplateModel, logo) {
		if (!invoiceData) {
			invoiceData = this.dataDefault();
		}
		this.isPDFGenerated = true;
		var templates = [(i, l) => {
			this.template1(i, l)
		}, (i, l) => {
			this.template2(i, l)
		}, (i, l) => {
			this.template3(i, l)
		}, (i, l) => {
			this.template4(i, l)
		}, (i, l) => {
			this.template5(i, l)
		}, (i, l) => {
			this.template6(i, l)
		}, (i, l) => {
			this.ticket(i, l)
		}];
		this.fcolor = templateData.fcolor;
		this.scolor = templateData.scolor;
		this.tcolor = templateData.tcolor;
		var handle = (dataUrl: string) => {
			const img = new Image();
			img.onload = () => {
				const canvas = document.createElement('canvas');
				canvas.width = img.width;
				canvas.height = img.height;
				const context = canvas.getContext('2d');
				if (context) {
					context.drawImage(img, 0, 0);
					const dataURL = canvas.toDataURL('image/png');
					const logoData = { logo: dataURL, w: img.width, h: img.height };
					if (invoiceData.items && invoiceData.items.length <= 9 && templateData.id == 1) {
						this.halfLetter(invoiceData, logoData);
					} else {
						templates[templateData.id - 1](invoiceData, logoData)
					}
				}
			};
			img.src = dataUrl;
		}
		this.convertNullToSpace(invoiceData);
		/* if (typeof invoiceData.seller !== 'object') {
			invoiceData.seller = { information: { state: '', name: '', street1: '', city: '' }, nit: '' };
		} */
		var calling = () => {
			if (logo) {
				//getStringImage(logo, templateData, invoiceData);
				var urlImage = (logo == 'preview') ? 'assets/img/logo-example.png' : logo;
				this.templateService.getImageDataUrl(urlImage).subscribe(
					(dataUrl: string) => {
						handle(dataUrl);
					},
					(error) => {
						if (invoiceData.items && invoiceData.items.length <= 9 && templateData.id == 1) {
							this.halfLetter(invoiceData, null);
						} else {
							templates[templateData.id - 1](invoiceData, null);
						}
					}
				);
			} else {
				if (invoiceData.items && invoiceData.items.length <= 9 && templateData.id == 1) {
					this.halfLetter(invoiceData, null);
				} else {
					templates[templateData.id - 1](invoiceData, null);
				}
			}
		}
		if (!invoiceData.certifier.signature && (invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM)) {
			this.templateService.getCertifierData(invoiceData.invoice.serial, invoiceData.invoice.number).subscribe({
				next: (response: ResponseObject) => {
					invoiceData.certifier.signature = "Número de autorización: " + response.data.authorizationNumber;
					invoiceData.certifier.data = response.data.certifierName;
					invoiceData.certifier.nit = response.data.certifierNit;
					const date = new Date(response.data.createDateFel);
					invoiceData.certifier.date = this.datePipe.transform(date, 'dd/MM/yyyy HH:mm:ss');
					calling();
				},
				error: (error: HttpErrorResponse) => {
					invoiceData.certifier.signature = "";
					invoiceData.certifier.data = "";
					invoiceData.certifier.nit = "";
					invoiceData.certifier.date = "";
					calling();
				}
			})
		} else {
			calling();
		}
	}

	addCustomFonts(doc) {
		doc.addFileToVFS("Nunito-normal.ttf", this.nunitoNormal);
		doc.addFileToVFS("Nunito-bold.ttf", this.nunitoBold);
		doc.addFont("Nunito-normal.ttf", "nunito", "normal");
		doc.addFont("Nunito-bold.ttf", "nunito", "bold");
	}

	async halfLetter(invoiceData: InvoiceTemplateModel, logo) {
		const width_page = 459;
		const half_width = 229.5;
		const half_height = 297;
		const doc = new jsPDF('l', 'px', [width_page, half_height]) as any;
		this.addCustomFonts(doc);
		var itemsArray;
		if (invoiceData.type == InvoiceType.TRANSFER || invoiceData.type == InvoiceType.INVENTORY) {
			itemsArray = this.getItemsTransfer(invoiceData);
		} else {
			itemsArray = this.getInvoiceItems(invoiceData, false, invoiceData.type == InvoiceType.PROVIDER);
		}
		await this.getSVG('template1v1');
		const svgElement = this.testSvg;
		const margin = 15;
		this.processSvgAndAddToDoc(svgElement, doc, 1).then((imgLoaded) => {
			const startYMargin = 55;
			autoTable(doc, {
				startY: startYMargin,
				theme: 'striped',
				bodyStyles: { fontSize: this.fontSizeTBody },
				columnStyles: this.getColumnStylesForTemplates(invoiceData, doc.internal.pageSize.width - margin - margin + margin / 3),
				headStyles: { fillColor: this.fcolor, halign: 'center', textColor: "white", fontSize: this.fontSizeTHead },
				alternateRowStyles: { fillColor: "#efeaf3" },
				tableLineColor: "#efeaf3",
				margin: { top: margin, right: margin - margin / 3, left: margin, bottom: 74.25 },
				head: this.getColumnsByInvoiceType(invoiceData),
				body: itemsArray,
				styles: {
					fontSize: 9,
					textColor: "black"
				},
				didParseCell: (data) => {
					if (data.column.index !== 0) {
						data.cell.styles.halign = 'center';
					}
					this.dontWrapNumber(data, invoiceData);
				},
				willDrawPage: (HookData) => {
					if (HookData.pageNumber == 1) {
						doc.setFont("helvetica", 'normal', 'bold');
						doc.setFontSize(14);
						doc.setTextColor(this.fcolor);
						var invoiceType = this.titlesIn[invoiceData.type];
						this.putText(doc, null, invoiceType, margin + 0.5, 15 + 0.5, "left", "helvetica", 14);
						this.putText(doc, null, invoiceType, margin - 0.5, 15 + 0.5, "left", "helvetica", 14);
						doc.setTextColor('white');
						this.putText(doc, null, invoiceType, margin, 15, "left", "helvetica", 14);
						var y = doc.getTextDimensions('bq').h + 4;
						doc.setFontSize(10);
						y += doc.getTextDimensions('bq').h + 5
						doc.setTextColor(this.fcolor);
						if (invoiceData.type != InvoiceType.INVENTORY) {
							if (invoiceData.type != InvoiceType.TRANSFER) {
								this.putText(doc, invoiceData.client.name.toUpperCase().substring(0, 55) + (invoiceData.client.name.length > 55 ? "..." : ""), invoiceData.type == InvoiceType.PROVIDER ? "PROVEEDOR: " : "CLIENTE: ", margin + 0.5, y + 0.5, "left", "helvetica", 10);
								doc.setTextColor("white");
								this.putText(doc, invoiceData.client.name.toUpperCase().substring(0, 55) + (invoiceData.client.name.length > 55 ? "..." : ""), invoiceData.type == InvoiceType.PROVIDER ? "PROVEEDOR: " : "CLIENTE: ", margin, y, "left", "helvetica", 10);
							} else {
								this.putText(doc, invoiceData.carrier.name.toUpperCase().substring(0, 23) + (invoiceData.carrier.name.length > 37 ? "..." : ""), "TRANSPORTISTA: ", margin + 0.5, y + 0.5, "left", "helvetica", 10);
								doc.setTextColor("white");
								this.putText(doc, invoiceData.carrier.name.toUpperCase().substring(0, 23) + (invoiceData.carrier.name.length > 37 ? "..." : ""), "TRANSPORTISTA: ", margin, y, "left", "helvetica", 10);
							}
							if (invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.BACKEND || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM) {
								this.putText(doc, invoiceData.invoice.serial, "SERIE: ", doc.internal.pageSize.width * 3 / 5 + 0.5, y + 0.5, "left", "helvetica", 10);
								doc.setTextColor(this.fcolor);
								this.putText(doc, invoiceData.invoice.serial, "SERIE: ", doc.internal.pageSize.width * 3 / 5, y, "left", "helvetica", 10);
								this.putText(doc, invoiceData.invoice.number, "NÚMERO: ", doc.internal.pageSize.width * 4 / 5, y, "left", "helvetica", 10);
							}
							doc.setTextColor('white');
							y += doc.getTextDimensions('bq').h + 1
							doc.setTextColor(this.fcolor);
							if (invoiceData.type != InvoiceType.TRANSFER) {
								this.putText(doc, invoiceData.client.address.toUpperCase().substring(0, 55) + (invoiceData.client.address.length > 55 ? "..." : ""), "DIRECCIÓN: ", margin + 0.5, y + 0.5, "left", "helvetica", 10);
								doc.setTextColor("white");
								this.putText(doc, invoiceData.client.address.toUpperCase().substring(0, 55) + (invoiceData.client.address.length > 55 ? "..." : ""), "DIRECCIÓN: ", margin, y, "left", "helvetica", 10);
							} else {
								this.putText(
									doc,
									invoiceData.carrier.destination.toUpperCase().substring(0, 30) + (invoiceData.carrier.destination.length > 55 ? "..." : ""),
									"DESTINO: ", margin + 0.5, y + 0.5, "left", "helvetica", 10);
								doc.setTextColor("white");
								this.putText(
									doc,
									invoiceData.carrier.destination.toUpperCase().substring(0, 30) + (invoiceData.carrier.destination.length > 55 ? "..." : ""),
									"DESTINO: ", margin, y, "left", "helvetica", 10);
							}
							doc.setTextColor(this.fcolor);
							if (invoiceData.type != InvoiceType.TRANSFER) {
								const fullDate = invoiceData.invoice.accountingDate || invoiceData.certifier.date || invoiceData.invoice.date;
								const dateOnly = fullDate?.split(" ")[0]
								this.putText(doc, dateOnly, "FECHA: ", doc.internal.pageSize.width * 3 / 5, y, "left", "helvetica", 10);
								if (invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.BACKEND || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM) {
									this.putText(doc, invoiceData.seller.nit, "NIT: ", doc.internal.pageSize.width * 4 / 5, y, "left", "helvetica", 10);
								}
								if (invoiceData.type == InvoiceType.QUOTATION) {
									this.putText(doc, invoiceData.invoice.number, "NUMERO: ", doc.internal.pageSize.width * 4 / 5, y, "left", "helvetica", 10);
								}
							} else {
								this.putText(doc, invoiceData.carrier.date, "FECHA: ", doc.internal.pageSize.width * 3 / 5, y, "left", "helvetica", 10);
								this.putText(doc, invoiceData.carrier.plate, "PLACA: ", doc.internal.pageSize.width * 4 / 5, y, "left", "helvetica", 10);
							}
							doc.setTextColor('white');
							y += doc.getTextDimensions('bq').h + 1
							this.putText(doc, (invoiceData.type != InvoiceType.TRANSFER) ? invoiceData.client.nit : invoiceData.carrier.nit, "NIT: ", margin, y, "left", "helvetica", 10);
						} else {
							this.putText(doc, invoiceData.inventory.name.toUpperCase().substring(0, 25) + (invoiceData.inventory.name.length > 25 ? "..." : ""), "REALIZADOR: ", margin + 0.5, y + 0.5, "left", "helvetica", 10);
							doc.setTextColor("white");
							this.putText(doc, invoiceData.inventory.name.toUpperCase().substring(0, 25) + (invoiceData.inventory.name.length > 25 ? "..." : ""), "REALIZADOR: ", margin, y, "left", "helvetica", 10);
							y += doc.getTextDimensions('bq').h + 2;
							doc.setTextColor(this.fcolor);
							this.putText(doc, invoiceData.inventory.warehouse.toUpperCase().substring(0, 25) + (invoiceData.inventory.warehouse.length > 25 ? "..." : ""), "BODEGA: ", margin + 0.5, y + 0.5, "left", "helvetica", 10);
							doc.setTextColor("white");
							this.putText(doc, invoiceData.inventory.warehouse.toUpperCase().substring(0, 25) + (invoiceData.inventory.warehouse.length > 25 ? "..." : ""), "BODEGA: ", margin, y, "left", "helvetica", 10);
							doc.setTextColor('white');
							y += doc.getTextDimensions('bq').h + 1
							this.putText(doc, invoiceData.inventory.date, "FECHA: ", margin, y, "left", "helvetica", 10);
						}
						if (logo) {
							console.log(logo);
							var height = 50;
							var width = height * logo.w / logo.h;
							doc.addImage(logo.logo, "JPEG", half_width - width / 2, startYMargin / 2 - height / 2, width, height, 'FAST');
						}
						if (this.dataUrl) {
							var height = 50;
							var width = height * this.dataUrl.width / this.dataUrl.height;
							doc.addImage(this.dataUrl, "PNG", half_width - width / 2, startYMargin / 2 - height / 2, height, height, "FAST");
						}
					}
				},
				didDrawPage: (HookData) => {
					if (invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM) {
						var data = [
							invoiceData.certifier.signature,
							'Fecha Certificación: ' + invoiceData.certifier.date,
							'Datos Cetificador: ' + invoiceData.certifier.data + ' NIT: ' + invoiceData.certifier.nit,
							'DOCUMENTO TRIBUTARIO ELECTRÓNICO'
						]
						var origin = half_height - 35;
						var position = doc.internal.pageSize.width - margin + margin / 3;

						if (invoiceData.type == InvoiceType.FCAM) {
							this.putFcamProtest(
								doc,
								invoiceData,
								6,
								half_height - 33,
								250,
								'left',
								'helvetica',
								5,
								'black'
							);
						}

						var tempSpace = 0;
						var gap = 2;
						doc.setFontSize(9);
						for (let i = 0; i < data.length; i++) {
							const element = data[i];
							if (i == data.length - 1) {
								doc.setFontSize(10);
								doc.setFont("helvetica", 'normal', 'bold');
							}
							if (invoiceData.total >= 0) {
								doc.setTextColor(this.fcolor);
								doc.text(element, position, origin + tempSpace, { align: 'right' });
								doc.setTextColor('white');
								doc.text(element, position, origin + tempSpace + 0.5, { align: 'right' });
							}
							if (i != data.length - 1)
								tempSpace += doc.getTextDimensions('bp').h + gap;
						}
					}
				}
			})
			var position_origin = doc.lastAutoTable.finalY;
			var client_data = [];
			if (invoiceData.type != InvoiceType.INVENTORY) {
				if (invoiceData.type != InvoiceType.TRANSFER) {
					client_data = [
						invoiceData.seller.name,
						(invoiceData.warehouse.name) ? invoiceData.warehouse.name : '',
						invoiceData.warehouse.address,
						(invoiceData.warehouse.number) ? "Tel. " + invoiceData.warehouse.number : ''
					]
				} else {
					client_data = [
						'ORIGEN',
						(invoiceData.warehouse.name) ? invoiceData.warehouse.name : '',
						invoiceData.carrier.description
					]
				}
			}
			const total_data = [
				'TOTAL', invoiceData.total
			]
			total_data[1] = this.getNumberLikeMoneyCurrency(total_data[1], invoiceData.currency);

			const total_advance = [
				'ANTICIPO', invoiceData.totalAdvance
			]
			total_advance[1] = this.getNumberLikeMoneyCurrency(total_advance[1], invoiceData.currency);

			var client_space = 0;
			if (invoiceData.type != InvoiceType.PROVIDER &&
				invoiceData.type != InvoiceType.TRANSFER &&
				invoiceData.type != InvoiceType.INVENTORY) {
				doc.setFontSize(9);
				doc.setFont("helvetica", 'normal', 'bold');
				//var textWidth = doc.getTextWidth(invoiceData.phrase);
				var phrase = (invoiceData.phrase) ? invoiceData.phrase : 'SUJETO A PAGOS TRIMESTRALES';
				var textWidth = doc.getTextWidth(phrase);
				doc.setFillColor("#efeaf3");
				doc.setFontSize(11);

				var heightFont11 = doc.getTextDimensions('bp').h;
				var temporalMargin = margin - margin / 3;

				const rightX = doc.internal.pageSize.width - temporalMargin;
				const boxWidth = textWidth;
				const boxX = rightX - boxWidth;

				if (invoiceData.type === InvoiceType.ADVANCE) {
					const boxHeight = heightFont11 * 2 + 14;

					doc.roundedRect(
						boxX,
						position_origin + 2,
						boxWidth,
						boxHeight,
						5,
						5,
						'F'
					);

					const totalY = position_origin + 14;

					doc.setTextColor('black');
					doc.setFont("helvetica", 'normal', 'bold');

					doc.text(
						total_data[0],
						boxX + 5,
						totalY,
						{ align: 'left' }
					);

					doc.setTextColor(this.fcolor);
					doc.setFont('helvetica', 'normal', 'normal');

					doc.text(
						total_data[1],
						rightX - 5,
						totalY,
						{ align: 'right' }
					);

					const advanceY = totalY + heightFont11 + 5;

					doc.setTextColor('black');
					doc.setFont("helvetica", 'normal', 'bold');

					doc.text(
						total_advance[0],
						boxX + 5,
						advanceY,
						{ align: 'left' }
					);

					doc.setTextColor(this.fcolor);
					doc.setFont('helvetica', 'normal', 'normal');

					doc.text(
						total_advance[1],
						rightX - 5,
						advanceY,
						{ align: 'right' }
					);

				} else {

					// Comportamiento normal para los demás documentos
					doc.roundedRect(
						boxX,
						position_origin + 2,
						boxWidth,
						heightFont11 + 10,
						5,
						5,
						'F'
					);

					doc.setTextColor('black');
					doc.setFont("helvetica", 'normal', 'bold');

					doc.text(
						total_data[0],
						boxX + 5,
						position_origin + 14,
						{ align: 'left' }
					);

					doc.setTextColor(this.fcolor);
					doc.setFont('helvetica', 'normal', 'normal');

					doc.text(
						total_data[1],
						rightX - 5,
						position_origin + 14,
						{ align: 'right' }
					);
				}

				this.putSubsidyBelowTotal(
					doc,
					invoiceData,
					doc.internal.pageSize.width - temporalMargin - 5,
					position_origin + 35,
					'right',
					'helvetica',
					this.fcolor,
					0
				);
				this.putRegularTextBelowTotal(
					doc,
					invoiceData,
					doc.internal.pageSize.width - temporalMargin - 5,
					position_origin + 35,
					'right',
					'helvetica',
					this.fcolor,
					0
				);
				doc.setTextColor('black');
				doc.setFontSize(9);
				doc.setFont("helvetica", 'normal', 'bold');
				if (invoiceData.type != InvoiceType.QUOTATION) {
					if(invoiceData.type != InvoiceType.ADVANCE){
						doc.text(phrase, doc.internal.pageSize.width - temporalMargin, position_origin + 20 + heightFont11, { align: 'right' });
					}
				} else {
					doc.setFont("helvetica", "normal", "bold");
					doc.setFontSize(11);
					const quots = doc.splitTextToSize(this.quotationMessage, 180);
					const baseY = position_origin + 20 + heightFont11;

					doc.text(quots,doc.internal.pageSize.width - temporalMargin,baseY,{ align: 'right' });

					doc.setFontSize(10);
					doc.setFont("helvetica", "normal", "normal");

					const validityY = baseY + doc.getTextDimensions(quots).h + 4;
					doc.text(
						this.quotationValidity,
						doc.internal.pageSize.width - temporalMargin,
						validityY,
						{ align: 'right' }
					);
				}
			}
			for (let i = 0; i < client_data.length; i++) {
				var text = this.splitText(client_data[i], 77);
				var parts;
				if (invoiceData.type != InvoiceType.TRANSFER) {
					parts = doc.splitTextToSize(text, 150);
				} else {
					parts = doc.splitTextToSize(client_data[i], 455);
				}
				if (i == 0) {
					doc.setFont("helvetica", 'normal', 'bold');
					doc.setTextColor("black");
					doc.setFontSize(11);
				} else if (i == 1) {
					doc.setFont("helvetica", 'normal', 'normal');
					doc.setTextColor("black");
					doc.setFontSize(10);
				} else {
					doc.setFontSize(9);
					doc.setTextColor("black");
					doc.setFont('helvetica', 'normal', 'normal');
				}
				doc.text(parts, margin, position_origin + 12 + client_space, { align: 'left' });
				client_space += doc.getTextDimensions(parts).h + 2;
			}
			if (invoiceData.type == InvoiceType.INVENTORY) {
				doc.setLineWidth(1);
				position_origin += 30;
				var firstQuarter = doc.internal.pageSize.width / 4;
				var thridQuarter = doc.internal.pageSize.width * 3 / 4;
				doc.line(firstQuarter - 50, position_origin, firstQuarter + 50, position_origin);
				this.putText(doc, null, "FIRMA REALIZADOR", firstQuarter, position_origin + 10, "center", "helvetica", 10);
				doc.line(thridQuarter - 50, position_origin, thridQuarter + 50, position_origin);
				this.putText(doc, null, "FIRMA ENCARGADO", thridQuarter, position_origin + 10, "center", "helvetica", 10);
			}
			delete this.isLoading[invoiceData['id'] ? invoiceData['id'] : 1];

			// this.addFcamProtestPage(doc, invoiceData);

			if (this.visor) {
				var string = doc.output('datauristring');
				var embed = "<embed width='100%' height='100%' src='" + string + "'/>"
				this.visor.innerHTML = embed;
			} else {
				if (invoiceData.type == InvoiceType.QUOTATION) {
					doc.save("COTIZACION-" + invoiceData.invoice.number + ".pdf");
				}else if (invoiceData.type == InvoiceType.ADVANCE) {
					doc.save("ANTICIPO.pdf");
				} else {
					doc.save(invoiceData.invoice.serial + "-" + invoiceData.invoice.number + ".pdf");
				}
			}
			return string;
		})
	}

	async ticket(invoiceData: InvoiceTemplateModel, logo) {

		const pdfWidth = 80;
		var itemsArray = this.getItems(invoiceData, false);
		const startYMargin = 21;
		const clientNamePos = 2;
		const tempDoc = new jsPDF({
			orientation: 'portrait',
			unit: 'mm',
			format: [pdfWidth, 5000]
		}) as any;
		this.setTableForTicket(tempDoc, startYMargin, parts, invoiceData, itemsArray);
		var additional = 0;
		const fcamExtraHeight = invoiceData.type == InvoiceType.FCAM ? 35 : 0;
		let subsidyExtraHeight = 0;
		if (invoiceData.type != InvoiceType.BACKEND && invoiceData.type != InvoiceType.QUOTATION && invoiceData.type != InvoiceType.ADVANCE && invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.INVENTORY) {
			if (invoiceData.totalSubsidy && invoiceData.totalSubsidy > 0) {
				subsidyExtraHeight = 10;
			}
		}
		var height = tempDoc.lastAutoTable.finalY + 15
			+ ((invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM) ? 40 : 0)
			+ fcamExtraHeight + subsidyExtraHeight
			+ (invoiceData.type == InvoiceType.INVENTORY ? 20 : 0);
		const doc = new jsPDF({
			orientation: pdfWidth < height ? 'portrait' : 'landscape',
			unit: 'mm',
			format: [pdfWidth, height]
		}) as any;
		var titles = ['DOCUMENTO ELECTRONICO', 'FACTURA ELECTRONICA', 'COTIZACIÓN', 'COMPRA', 'TRASLADO', 'REALIZACIÓN DE INVENTARIO', 'NOTA DE CRÉDITO ELECTRONICA', 'FACTURA ELECTRONICA CAMBIARIA', 'ANTICIPO'];
		var title = titles[invoiceData.type];
		var clientOrigin = 15;
		this.putText(doc, null, title, 40, 5, 'center', 'helvetica', 10);
		if (invoiceData.type != InvoiceType.INVENTORY && invoiceData.type != InvoiceType.PROVIDER && invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.ADVANCE) {
			if (invoiceData.type != InvoiceType.QUOTATION) {
				this.putText(doc,
					invoiceData.seller.name.toUpperCase().substring(0, 35) + ((invoiceData.seller.name.length > 35) ? "..." : ""),
					null, 40, 8, 'center', 'helvetica', 9);
				this.putText(doc, invoiceData.invoice.serial, "SERIE: ", clientNamePos, 10.5, 'left', 'helvetica', 7);
				this.putText(doc, invoiceData.invoice.number, "NUMERO: ", 28, 10.5, 'left', 'helvetica', 7);
				this.putText(doc, invoiceData.seller.nit, "NIT: ", 56, 10.5, 'left', 'helvetica', 7);
			} else {
				this.putText(doc,
					invoiceData.warehouse.name.toUpperCase().substring(0, 33) + ((invoiceData.warehouse.name.length > 33) ? "..." : ""),
					null, 40, 8, 'center', 'helvetica', 9);
				doc.setFontSize(7);
				this.putText(doc, "COTIZACIÓN NO: ", invoiceData.invoice.number, doc.internal.pageSize.width / 2 + doc.getTextWidth("COTIZACIÓN NO: " + invoiceData.invoice.number) / 2, 10.5, 'right', 'helvetica', 7);
				//this.putText(doc, "NUMERO: ", invoiceData.invoice.number, 70, 10.5, 'right', 'helvetica', 7);
			}
			doc.line(20, 12, 60, 12);
			clientOrigin = 15;
		} else {
			this.putText(doc,
				invoiceData.inventory.warehouse.toUpperCase().substring(0, 33) + ((invoiceData.inventory.warehouse.length > 33) ? "..." : ""),
				null, 40, 8, 'center', 'helvetica', 9);
			clientOrigin = 13;
		}
		var sizeSpaces = 3;
		if (invoiceData.type != InvoiceType.INVENTORY) {
			if (invoiceData.type != InvoiceType.TRANSFER) {
				this.putText(doc, invoiceData.client.name.toUpperCase().substring(0, 33), invoiceData.type == InvoiceType.PROVIDER ? "PROVEEDOR: " : "CLIENTE: ", clientNamePos, clientOrigin);
				this.putText(doc, invoiceData.client.address.toUpperCase().substring(0, 33), "DIRECCIÓN: ", clientNamePos, clientOrigin + doc.getTextDimensions("H").h);
				this.putText(doc, invoiceData.client.nit, "NIT: ", clientNamePos, clientOrigin + doc.getTextDimensions("H").h * 2);
				let dateToUse = invoiceData.invoice.accountingDate || invoiceData.invoice.date;
				this.putText(doc, dateToUse, "FECHA: ", 40, clientOrigin + doc.getTextDimensions("H").h * 2);
			} else {
				additional += sizeSpaces * 1.5;
				this.putText(doc, invoiceData.carrier.name.toUpperCase().substring(0, 26), "TRANSPORTISTA: ", clientNamePos, clientOrigin);
				this.putText(doc, invoiceData.carrier.description.substring(0, 31), "DESCRIPCION: ", clientNamePos, clientOrigin + sizeSpaces);
				this.putText(doc, invoiceData.carrier.destination.toUpperCase().substring(0, 31), "DESTINO: ", clientNamePos, clientOrigin + sizeSpaces * 2);
				this.putText(doc, invoiceData.carrier.nit, "NIT: ", clientNamePos, clientOrigin + sizeSpaces * 3, 'left', 'helvetica', 7);
				this.putText(doc, invoiceData.carrier.plate, "PLACA: ", 28, clientOrigin + sizeSpaces * 3, 'left', 'helvetica', 7);
				this.putText(doc, invoiceData.carrier.date, "FECHA: ", 56, clientOrigin + sizeSpaces * 3, 'left', 'helvetica', 7);
			}
		} else {
			clientOrigin = 11
			var identification = "REALIZADOR: ";
			additional = -6;
			this.putText(doc, invoiceData.inventory.name, identification,
				40 - doc.getTextWidth(identification + invoiceData.inventory.name) / 2, clientOrigin);
			this.putText(doc, invoiceData.inventory.date, "FECHA: ",
				40 - doc.getTextWidth("FECHA: " + invoiceData.inventory.date) / 2, clientOrigin + sizeSpaces, 'left', 'helvetica', 7);
		}
		var parts = [];
		if (invoiceData.type == InvoiceType.QUOTATION) {
			parts = doc.splitTextToSize("Con mucho gusto le presentamos nuestra oferta de acuerdo a su amable solicitud, contáctenos para poder servirle. Vigencia 3 días a partir de la fecha emitida.",
				76);
			doc.text(parts, clientNamePos, clientOrigin + doc.getTextDimensions("H").h * 3, { align: 'left' });
		}
		this.setTableForTicket(doc, startYMargin, parts, invoiceData, itemsArray, additional);
		var end = doc.lastAutoTable.finalY + 3;
		if (invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.INVENTORY) {
			this.putText(doc, "TOTAL: ", this.getNumberLikeMoneyCurrency(invoiceData.total, invoiceData.currency), 78, end, 'right', 'helvetica', 8);
			end += doc.getTextDimensions("TOTAL: ").h + 2;
		} else {
			end += 2;
		}
		if (invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.INVENTORY) {
			this.putText(doc, invoiceData.warehouse.name.toUpperCase().substring(0, 40) + ((invoiceData.warehouse.name.length > 40) ? '...' : ''), null, clientNamePos, end);
			end += doc.getTextDimensions("TOTAL: ").h + 1;

			const warehouseAddress = (invoiceData.warehouse.address ? invoiceData.warehouse.address : "Ciudad").toUpperCase();

			end = this.drawMultiColumnLabeledText(
			doc,
			warehouseAddress,
			"DIRECCIÓN: ",
			clientNamePos,
			end,
			{
				columns: 2,
				colWidth: 40,
				gap: 4,
				font: 'helvetica',
				fz: 7,
				maxLinesPerCol: 3,
				align: 'left'
			}
			);

			end += 1;


			this.putText(doc, invoiceData.warehouse.number ? invoiceData.warehouse.number + ' ' : '', invoiceData.warehouse.number ? "TEL: " : "", clientNamePos, end);
			end += doc.getTextDimensions("TOTAL: ").h + 3;
		}
		if (invoiceData.type == InvoiceType.INVENTORY) {
			doc.setLineWidth(0.5);
			end += doc.getTextDimensions("TOTAL: ").h + 5;
			doc.line(20, end, 60, end);
			end += 3;
			this.putText(doc, null, "FIRMA REALIZADOR", 40, end, "center");
			end += doc.getTextDimensions("TOTAL: ").h * 2 + 8;
			doc.line(20, end, 60, end);
			end += 3;
			this.putText(doc, null, "FIRMA ENCARGADO", 40, end, "center");
			end += doc.getTextDimensions("TOTAL: ").h + 3;
		}
		if (invoiceData.type != InvoiceType.BACKEND && invoiceData.type != InvoiceType.QUOTATION && invoiceData.type != InvoiceType.ADVANCE && invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.INVENTORY) {
			if (invoiceData.totalSubsidy && invoiceData.totalSubsidy > 0) {
			const totalWithoutSubsidy =
				Number(invoiceData.total || 0) +
				Number(invoiceData.totalSubsidy || 0);

			const subsidyText =
				`Esta factura incluye apoyo social temporal Decreto 11-2026 por un valor de ${this.getNumberLikeMoneyCurrency(invoiceData.totalSubsidy, invoiceData.currency)}`;

			const subsidyLines = doc.splitTextToSize(subsidyText, 76);

			doc.setFont("helvetica", "normal");
			doc.setFontSize(6);
			doc.text(subsidyLines, clientNamePos, end);

			end += (subsidyLines.length * 3);

			const totalText =
				`Monto total a pagar sin apoyo social temporal ${this.getNumberLikeMoneyCurrency(totalWithoutSubsidy, invoiceData.currency)}`;

			const totalLines = doc.splitTextToSize(totalText, 76);

			doc.text(totalLines, clientNamePos, end);

			end += (totalLines.length * 3) + 2;
			}
		}
		if (invoiceData.type != InvoiceType.BACKEND && invoiceData.type != InvoiceType.QUOTATION && invoiceData.type != InvoiceType.ADVANCE && invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.INVENTORY) {
			if (invoiceData.hasRegularExtraTax) {
				const regularText =
					`El 90% de la mezcla de gasolina regular incluida en este documento está afecta al IDP (Ac. Gub. 257- 2025 y Ac. Ministerial 333-2026).`;

				const regularLines = doc.splitTextToSize(regularText, 76);

				doc.setFont("helvetica", "normal");
				doc.setFontSize(6);
				doc.text(regularLines, clientNamePos, end);

				end += (regularLines.length * 3);
			}
		}

		if (invoiceData.type != InvoiceType.BACKEND && invoiceData.type != InvoiceType.QUOTATION && invoiceData.type != InvoiceType.ADVANCE && invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.INVENTORY) {
			if (invoiceData.type == InvoiceType.FCAM) {
				end = this.putFcamProtest(
					doc,
					invoiceData,
					clientNamePos,
					end,
					76,
					'left',
					'helvetica',
					5,
					'black'
				);

				end += 1;
			}
			this.putText(doc, null, "DATOS CERTIFICACIÓN", clientNamePos, end, "left", "helvetica", 8);
			end += doc.getTextDimensions("TOTAL: ").h + 1;
			this.putText(doc, invoiceData.certifier.signature.substring(23, invoiceData.certifier.signature.length), "# AUTORIZACIÓN: ", clientNamePos, end, "left", "helvetica", 7);
			end += doc.getTextDimensions("TOTAL: ").h + 1;
			this.putText(doc, invoiceData.certifier.date, "FECHA: ", clientNamePos, end, "left", "helvetica", 7);
			end += doc.getTextDimensions("TOTAL: ").h + 1;
			this.putText(doc, invoiceData.certifier.data, "DATOS: ", clientNamePos, end, "left", "helvetica", 7);
			end += doc.getTextDimensions("TOTAL: ").h + 1;
			this.putText(doc, invoiceData.certifier.nit, "NIT: ", clientNamePos, end, "left", "helvetica", 7);
			end += doc.getTextDimensions("TOTAL: ").h + 3;
			this.putText(doc, null, "DOCUMENTO TRIBUTARIO ELECTRONICO", clientNamePos, end, "left", "helvetica", 9);
		}
		return this.finalizePDF(invoiceData, doc, 7);

	}

	setTableForTicket(doc, startYMargin, parts, invoiceData, itemsArray, additional = 0) {
		var startY = parts ? startYMargin + doc.getTextDimensions("H").h * parts.length + additional
			: startYMargin + ((invoiceData.type == InvoiceType.QUOTATION || invoiceData.type == InvoiceType.ADVANCE) ? doc.getTextDimensions("H").h * 2 : 0);
		autoTable(doc, {
			startY: startY,
			theme: 'plain',
			columnStyles: this.getColumnStyles(invoiceData),
			styles: {  // Ajusta el texto a múltiples líneas si es demasiado largo
				fontSize: 7,             // Ajusta el tamaño de la fuente si es necesario
				cellPadding: 0.5,
				halign: 'center'
			},
			tableLineColor: "#efeaf3",
			margin: { top: 0, right: 2, left: 2, bottom: 0 },
			head: this.getColumnsByInvoiceType(invoiceData),
			body: itemsArray
			,
			didParseCell: (data) => {
				if (data.column.index == 3) {
					data.cell.styles.halign = 'right'
				} else if (data.column.index == 0) {
					data.cell.styles.halign = 'left'
				} var start = 0;
				if (invoiceData.type == InvoiceType.PROVIDER) {
					start++;
				}
				if (data.cell.text[0].length > 25) {
					data.cell.styles.fontSize = 6;
				}
				if (data.column.index > start) {
					data.cell.styles["whiteSpace"] = 'nowrap';
					data.cell.styles.overflow = 'hidden';
				}
			}
		});
	}

	getColumnStylesForTemplates(invoiceData: InvoiceTemplateModel, width, isTemplate5 = false) {
		if (invoiceData.type == InvoiceType.PROVIDER || invoiceData.type == InvoiceType.TRANSFER || invoiceData.type == InvoiceType.INVENTORY) {
			return {
				0: { cellWidth: 60 },
				2: { cellWidth: 90 }
			}
		} else {
			var widthNumber = 90;
			if (isTemplate5) {
				return {
					0: { cellWidth: 60 },
					2: { cellWidth: widthNumber - 20 },
					3: { cellWidth: widthNumber },
				}
			} else {
				return {
					1: { cellWidth: widthNumber - 30 },
					2: { cellWidth: widthNumber - 20 },
					3: { cellWidth: widthNumber }
				}
			}
		}
	}

	getColumnStyles(invoiceData) {
		if (invoiceData.type == InvoiceType.PROVIDER) {
			return {
				0: { cellWidth: 19 },
				1: { cellWidth: 39 },
				2: { cellWidth: 19 }
			}
		} else if (invoiceData.type == InvoiceType.TRANSFER || invoiceData.type == InvoiceType.INVENTORY) {
			return {
				0: { cellWidth: 19 },
				1: { cellWidth: 39 },
				2: { cellWidth: 19 }
			}
		} else {
			return {
				0: { cellWidth: 23 },
				1: { cellWidth: 15 },
				2: { cellWidth: 17 },
				3: { cellWidth: 18 }
			}
		}
	}

	getColumnsByInvoiceType(invoiceData, isTemplate5 = false) {
		const includesExtraTax = invoiceData.items.some(i => i.extraTax && i.extraTax > 0);

		if (invoiceData.type == InvoiceType.PROVIDER || invoiceData.type == InvoiceType.TRANSFER || invoiceData.type == InvoiceType.INVENTORY) {
			if (isTemplate5) {
				return [['Cantidad', 'Producto', 'Codigo']];
			}
			return [['Codigo', 'Producto', 'Cantidad']];
		} else {
			if (isTemplate5) {
				return includesExtraTax
					? [['Cantidad', 'Producto', 'Precio Unitario', 'Impuesto Extra', 'Total']]
					: [['Cantidad', 'Producto', 'Precio Unitario', 'Total']];
			}
			return includesExtraTax
				? [['Producto', 'Cantidad', 'Precio Unitario', 'Impuesto Extra', 'Total']]
				: [['Producto', 'Cantidad', 'Precio Unitario', 'Total']];
		}
	}

	putText(doc: any, text: string, title: string, x: number, y: number, align = "left", font = "helvetica", fz = 8) {
		doc.setFontSize(fz);
		var weight;
		if (title) {
			weight = align == 'right' ? 'normal' : 'bold';
		} else {
			weight = align == 'right' ? 'bold' : 'normal';
		}
		doc.setFont(font, 'normal', weight);
		doc.text(title ? title : text, x, y, { align: align });
		if (title && text) {
			var fright = align == 'right' ? -1 : 1;
			this.putText(doc, text, null, x + (doc.getTextWidth(title) + 0.5) * fright, y, align, font, fz);
		}
	}

	getInvoiceType(type: number): string {
		var invoiceType = "Factura Electronica";
		if (type == InvoiceType.BACKEND) {
			return invoiceType = "Documento Electronico"
		} else if (type == InvoiceType.PROVIDER) {
			return invoiceType = "Orden de Compra"
		} else if(type == InvoiceType.FCAM){
			return invoiceType = "Factura Electronica Cambiaria"
		}
		return invoiceType;
	}

	convertNullToSpace(obj) {
		for (const key in obj) {
			if (obj.hasOwnProperty(key)) {
				if (obj[key] === null) {
					obj[key] = ''; // Puedes cambiar esto a ' ' si prefieres un espacio en blanco
				} else if (typeof obj[key] === 'object') {
					this.convertNullToSpace(obj[key]); // Llamada recursiva para objetos anidados
				}
			}
		}
	}

	getItemsTransfer(invoiceData, isTemplate5 = false) {
		var itemsArray = [];
		invoiceData.items.forEach(element => {
			if (isTemplate5) {
				itemsArray.push([
					element.quantity,
					element.description,
					element.code
				])
			} else {
				itemsArray.push([
					element.code,
					element.description,
					element.quantity
				])
			}
		});
		return itemsArray;
	}

	getInvoiceItems(invoiceData, isTemplate5, isProviderInvoice) {
		const itemsArray = [];
		const money = invoiceData.currency ? 'en-US:USD' : 'es-GT:GTQ';
		const includesExtraTax = invoiceData.items.some(i => i.extraTax && i.extraTax > 0);

		invoiceData.items.forEach(element => {
			const formattedPrice = element.priceWithoutTax.toLocaleString(money.split(":")[0], { style: 'currency', currency: money.split(":")[1] });
			const formattedTotal = element.total.toLocaleString(money.split(":")[0], { style: 'currency', currency: money.split(":")[1] });
			const formattedExtraTax = element.extraTax && element.extraTax > 0
				? element.extraTax.toLocaleString(money.split(":")[0], { style: 'currency', currency: money.split(":")[1] })
				: null;

			if (isTemplate5) {
				if (isProviderInvoice) {
					const row = [
						element.description,
						element.code,
						formattedPrice,
					];
					if (includesExtraTax) row.push(formattedExtraTax);
					row.push(formattedTotal);
					row.push(element.quantity.toFixed(4));
					itemsArray.push(row);
				} else {
					const row = [
						element.quantity.toFixed(4),
						element.description,
						formattedPrice,
					];
					if (includesExtraTax) row.push(formattedExtraTax);
					row.push(formattedTotal);
					row.push(element.code);
					itemsArray.push(row);
				}
			} else {
				const row = [
					element.description,
					element.quantity.toFixed(4),
					formattedPrice,
				];
				if (includesExtraTax) row.push(formattedExtraTax);
				row.push(formattedTotal);
				row.push(element.code);
				itemsArray.push(row);
			}
		});

		if (isProviderInvoice) {
			itemsArray.forEach((i: any[]) => {
				i.unshift(i[i.length - 1]); // Mueve el código al inicio
			});
		}

		return itemsArray;
	}


	dontWrapNumber(cell: CellHookData, invoiceData: InvoiceTemplateModel) {
		var start = 0;
		if (invoiceData.type == InvoiceType.PROVIDER) {
			start++;
		}
		if (cell.cell.text[0].length > 40) {
			cell.cell.styles.fontSize = 8;
		}
		if (cell.column.index > start) {
			cell.cell.styles["whiteSpace"] = 'nowrap';
			cell.cell.styles.overflow = 'hidden';
		}
	}

	async template6(invoiceData: any, logo: any) {
		const doc = this.initializePDFLetter();
		const itemsArray = this.getItems(invoiceData);
		await this.getSVG('template6v1');
		const svgElement = this.testSvg;
		const margin = 40;
		this.processSvgAndAddToDoc(svgElement, doc, 6).then((imgLoaded) => {
			const startYMargin = doc.internal.pageSize.height / 3;
			autoTable(doc, {
				startY: startYMargin,
				theme: 'striped',
				columnStyles: this.getColumnStylesForTemplates(invoiceData, doc.internal.pageSize.width - margin),
				bodyStyles: { fontSize: this.fontSizeTBody },
				headStyles: { fillColor: this.fcolor, halign: 'center', fontSize: this.fontSizeTHead },
				alternateRowStyles: { fillColor: '#efeaf3' },
				tableLineColor: this.tcolor,
				margin: { top: margin, right: 0, left: margin, bottom: margin * 2 + 30 },
				head: this.getColumnsByInvoiceType(invoiceData),
				body: itemsArray,
				didParseCell: (cell: CellHookData) => {
					if (cell.column.index !== 0 || !this.addTotal(invoiceData)) {
						cell.cell.styles.halign = 'center';
					}
					this.dontWrapNumber(cell, invoiceData);
				},
				willDrawPage: (HookData) => {
					doc.addImage(
						imgLoaded,
						'JPEG',
						0,
						0,
						doc.internal.pageSize.width + 1,
						doc.internal.pageSize.height + 1,
						'NONE'
					);
					const client_data = [
						(invoiceData.warehouse.name) ? invoiceData.warehouse.name : '',
						(invoiceData.warehouse.number) ? "Tel. " + invoiceData.warehouse.number : ''
					]
					doc.setFont("nunito", 'normal', 'normal');
					doc.setTextColor(this.scolor);
					doc.setFontSize(11);
					for (let i = 0; i < client_data.length; i++) {
						var text = this.splitText(client_data[i].toUpperCase(), 60);
						var parts = doc.splitTextToSize(text, (i == 0) ? (margin * 3) : 60);
						var half = doc.getTextDimensions(parts).h / 2;
						if (i == 0) {
							doc.text(parts, doc.internal.pageSize.width - margin * 2.6, doc.internal.pageSize.height - margin + 14 - half, { align: 'right', baseline: 'top' });
						} else if (i == 1) {
							doc.text(parts, doc.internal.pageSize.width - margin * 2 + 10, doc.internal.pageSize.height - margin + 14 - half, { align: 'left', baseline: 'top' });
						}
					}
					if (HookData.pageNumber == 1) {
						var fieldsClient = [
							(invoiceData.type != InvoiceType.PROVIDER) ? 'Cliente:' : 'Proveedor:', 'NIT:', 'Fecha:'
						]
						var fieldsDoc = [
							'Serie:', 'Número:', 'NIT:'
						]
						var valuesClient = [
							invoiceData.client.name, invoiceData.client.nit, invoiceData.invoice.date
						];
						var valuesDoc =
							[
								invoiceData.invoice.serial, invoiceData.invoice.number, invoiceData.seller.nit
							]
						if (invoiceData.type == InvoiceType.INVENTORY) {
							fieldsClient = [
								'Realizador:', 'Bodega:', 'Fecha:'
							]
							var valuesClient = [
								invoiceData.inventory.name, invoiceData.inventory.warehouse, invoiceData.invoice.date
							];
							fieldsDoc = [];
							valuesDoc = [];
						}
						if (invoiceData.type == InvoiceType.PROVIDER) {
							fieldsDoc = [];
							valuesDoc = [];
						}
						if (invoiceData.type == InvoiceType.TRANSFER) {
							fieldsClient = [
								'Transporta:', 'Destino:', 'Descripción:'
							]
							var valuesClient = [
								invoiceData.carrier.name, invoiceData.carrier.destination, invoiceData.carrier.description
							];
							fieldsDoc = [
								'Fecha:', 'Placa:'];
							valuesDoc = [
								invoiceData.carrier.plate, invoiceData.carrier.date
							];
						}
						if (invoiceData.type == InvoiceType.QUOTATION) {
							fieldsClient = [
								'Cliente:', 'NIT:', 'Fecha:', 'Cotización:'
							]
							var valuesClient = [
								invoiceData.client.name, invoiceData.client.nit, invoiceData.invoice.date, invoiceData.invoice.number
							];
							fieldsDoc = [];
							valuesDoc = [
							];
						}
						if (invoiceData.type == InvoiceType.ADVANCE) {
							fieldsClient = [
								'Cliente:', 'NIT:', 'Fecha:', 'Anticipo:'
							]
							var valuesClient = [
								invoiceData.client.name, invoiceData.client.nit, invoiceData.invoice.date, invoiceData.invoice.number
							];
							fieldsDoc = [];
							valuesDoc = [
							];
						}
						valuesClient[0] = this.splitText(valuesClient[0], 77);
						const max_width_second = 'Número: xxxxxxxxxxxxxxxxx';
						const margin_right = doc.internal.pageSize.width - margin + margin / 3;
						var countSpace = 0;
						var tempGap = 7;
						doc.setFontSize(12);
						var parts = doc.splitTextToSize(valuesClient[0], 100);
						valuesClient[0] = parts;
						switch (invoiceData.type) {
							case InvoiceType.NORMAL:
								{
									doc.setTextColor(this.fcolor);
									this.putText(doc, null, "FACTURA", 375, 85, 'center', 'nunito', 28);
									doc.setTextColor(this.scolor);
									this.putText(doc, "ELECTRONICA", null, 375, 100, 'center', 'nunito', 20);
									break;
								}
							case InvoiceType.FCAM:
								{
									doc.setTextColor(this.fcolor);
									this.putText(doc, null, "FACTURA", 375, 85, 'center', 'nunito', 28);
									doc.setTextColor(this.scolor);
									this.putText(doc, "ELECTRONICA CAMBIARIA", null, 375, 100, 'center', 'nunito', 20);
									break;
								}
							
							case InvoiceType.NCRE:
								{
									doc.setTextColor(this.fcolor);
									this.putText(doc, null, "NOTA DE CRÉDITO", 375, 85, 'center', 'nunito', 28);
									doc.setTextColor(this.scolor);
									this.putText(doc, "ELECTRONICA", null, 375, 100, 'center', 'nunito', 20);
									break;
								}

							case InvoiceType.BACKEND:
								{
									doc.setTextColor(this.fcolor);
									this.putText(doc, null, "DOCUMENTO", 375, 85, 'center', 'nunito', 20.5);
									doc.setTextColor(this.scolor);
									this.putText(doc, "ELECTRONICO", null, 375, 100, 'center', 'nunito', 20);
									break;
								}

							case InvoiceType.PROVIDER:
								{
									doc.setTextColor(this.fcolor);
									this.putText(doc, null, "ORDEN", 375, 85, 'center', 'nunito', 32);
									doc.setTextColor(this.scolor);
									this.putText(doc, "DE COMPRA", null, 375, 100, 'center', 'nunito', 20);
									break;
								}

							case InvoiceType.INVENTORY:
								{
									doc.setTextColor(this.fcolor);
									this.putText(doc, null, "REALIZACIÓN", 375, 85, 'center', 'nunito', 22);
									doc.setTextColor(this.scolor);
									this.putText(doc, "DE INVENTARIO", null, 375, 100, 'center', 'nunito', 20);
									break;
								}


							default:
								{
									doc.setTextColor(this.fcolor);
									this.putText(doc, null, this.titlesIn[invoiceData.type], 370, 85, 'center', 'nunito', 28);
									break;
								}
						}
						var originX = doc.internal.pageSize.width - 160;
						var originY = 140;
						doc.setFontSize(12);
						doc.setTextColor(this.fcolor);
						var sum = 0;
						if (parts.length > 1) {
							sum = parts.length - 1;
							originY = originY - Math.round((sum / 2)) * 10;
						}
						var tempPositionY = 0;
						for (let i = 0; i < fieldsClient.length; i++) {
							var value = doc.splitTextToSize(this.splitText(valuesClient[i], 40), 95);
							doc.setFont("nunito", 'normal', 'normal');
							doc.text(value, originX + 55, originY + tempPositionY, { align: 'left' });
							doc.setFont("helvetica", 'normal', 'bold');
							doc.text(fieldsClient[i], originX, originY + tempPositionY, { align: 'left' });
							tempPositionY += doc.getTextDimensions(value).h;
						}
						for (let i = 0; i < fieldsDoc.length; i++) {
							doc.setFont("nunito", 'normal', 'normal');
							doc.text(valuesDoc[i], originX - 95, originY + i * 10, { align: 'left' });
							doc.setFont("helvetica", 'normal', 'bold');
							doc.text(fieldsDoc[i], originX - 140, originY + i * 10, { align: 'left' });
						}
						if (invoiceData.type == InvoiceType.QUOTATION) {
							doc.setFontSize(10);
							const xMsg = originX - 140;
							const yMsg = originY + 5;
							const msgLines = doc.splitTextToSize(this.quotationMessage, 140);
							this.putText(doc, msgLines, null, xMsg, yMsg, 'left', "nunito", 10);
							doc.setFontSize(9);
							const validityLines = doc.splitTextToSize(this.quotationValidity, 140);
							const yValidity = yMsg + doc.getTextDimensions(msgLines).h + 4;
							this.putText(doc, validityLines, null, xMsg, yValidity, 'left', "nunito", 9);
						}
						doc.setFontSize(13);
						doc.setFont("nunito", 'normal', 'normal');
						doc.text(doc.splitTextToSize(invoiceData.seller.name, 100), margin, originY, { align: 'left' });
						if (logo) {
							var height = 80;
							var width = height * logo.w / logo.h;
							doc.addImage(logo.logo, "JPEG", margin, margin / 2, height, height, 'FAST');
						}

						var data = [
							'DOCUMENTO TRIBUTARIO ELECTRÓNICO',
							invoiceData.certifier.signature,
							'Fecha Certificación: ' + invoiceData.certifier.date,
							'Cetificador: ' + invoiceData.certifier.data, 'NIT Certificador: ' + invoiceData.certifier.nit
						]
						var origin = doc.internal.pageSize.height - margin * 2;
						var position = margin;

						if (invoiceData.type == InvoiceType.FCAM) {
						this.putFcamProtest(
							doc,
							invoiceData,
							20,
							doc.internal.pageSize.height - 36,
							300,
							'left',
							'helvetica',
							4,
							'black'
						);
					}


						var tempSpace = 0;
						var gap = 2;
						doc.setFontSize(10);
						doc.setTextColor(this.fcolor);
						for (let i = 0; i < data.length && (invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM); i++) {
							const element = data[i];
							if (i == 0) {
								doc.setFont("nunito", 'normal', 'bold');
							} else {
								doc.setFontSize(9);
								doc.setFont("nunito", 'normal', 'normal');
							}
							if (invoiceData.total >= 0)
								doc.text(doc.splitTextToSize(element, 170), position, origin + tempSpace, { align: 'left' });
							if (i != data.length - 1)
								tempSpace += doc.getTextDimensions(doc.splitTextToSize(element, 160)).h + gap;
						}
						const total_data = [
							'TOTAL', invoiceData.total
						]
						total_data[1] = this.getNumberLikeMoneyCurrency(total_data[1], invoiceData.currency);
						var client_space = -10;
						if (this.addTotal(invoiceData)) {
							doc.setFontSize(9);
							//var textWidth = doc.getTextWidth(invoiceData.phrase);
							var phrase = (invoiceData.phrase) ? invoiceData.phrase : 'SUJETO A PAGOS TRIMESTRALES';
							var textWidth = doc.getTextWidth(phrase);
							doc.setFillColor('#efeaf3');
							doc.setFontSize(11);
							var temporalMargin = margin - margin / 3;
							doc.setTextColor(this.fcolor);
							doc.setFont("nunito", 'normal', 'bold');
							doc.text(total_data[0], doc.internal.pageSize.width / 2, doc.internal.pageSize.height - margin * 2 + client_space + 2, { align: 'left' });
							doc.setTextColor(this.scolor);
							doc.setFont('nunito', 'normal', 'bold');
							doc.text(total_data[1], doc.internal.pageSize.width - temporalMargin - 5, doc.internal.pageSize.height - margin * 2 + client_space + 2, { align: 'right' });
							this.putSubsidyBelowTotal(
								doc,
								invoiceData,
								doc.internal.pageSize.width - temporalMargin - 35,
								doc.internal.pageSize.height - margin * 2 + client_space + 10,
								'right',
								'nunito',
								this.fcolor,
								6
							);
							this.putRegularTextBelowTotal(
								doc,
								invoiceData,
								doc.internal.pageSize.width - temporalMargin - 35,
								doc.internal.pageSize.height - margin * 2 + client_space + 10,
								'right',
								'nunito',
								this.fcolor,
								6
							);
							doc.setTextColor('black');
							doc.setFontSize(9);
							doc.setFont("nunito", 'normal', 'bold');
							doc.text(
								doc.splitTextToSize(phrase, doc.internal.pageSize.width / 2 - temporalMargin),
								doc.internal.pageSize.width * 3 / 4 - temporalMargin / 2,
								doc.internal.pageSize.height - margin * 2 + client_space + 7 + doc.getTextDimensions('bp').h,
								{ align: 'center' });
						}

						if (invoiceData.type == InvoiceType.INVENTORY) {
							doc.setTextColor(this.fcolor);
							doc.setDrawColor(this.fcolor);
							this.putInventorySigns(doc, doc.internal.pageSize.height - margin * 2 - 5, true);
						}
					}
				},
				didDrawPage: (HookData) => {
					HookData.settings.margin.bottom = margin + 20;
					var footerNumber: string = 'Pagina ' + HookData.pageNumber;
					doc.setFontSize(12);
					doc.setTextColor(this.fcolor);
					doc.setFont("nunito", 'normal', 'bold');
					//doc.text(footerNumber, margin, doc.internal.pageSize.height - margin / 2 + 5, { align: 'left' });

				}
			})

			var pageCount = doc.internal.getNumberOfPages(); //Total Page Number
			for (var i = 0; i < pageCount; i++) {
				doc.setFontSize(12);
				doc.setTextColor(this.fcolor);
				doc.setFont("nunito", 'normal', 'bold');
				doc.setPage(i);
				let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
				doc.text('Página ' + pageCurrent + '/' + pageCount, margin, doc.internal.pageSize.height - margin / 2 + 5, { align: 'left' });
			}
			return this.finalizePDF(invoiceData, doc, 6);
		});
	}

	template5(invoiceData: InvoiceTemplateModel, logo) {
		const doc = this.initializePDFLetter();
		const itemsArray = this.getItems(invoiceData, true);
		const margin = 45;
		const widthFirstColumn = 60;
		var temp_margin = margin + widthFirstColumn + 10;
		const startYMargin = doc.internal.pageSize.height * 0.27;
		var space_for_data_bottom = 140;
		if (invoiceData.type == InvoiceType.TRANSFER || invoiceData.type == InvoiceType.PROVIDER) {
			space_for_data_bottom = 50;
		}
		var client_space = 60;
		doc.setFont("helvetica", 'normal', 'bold');
		doc.setTextColor(this.getContrastColor(this.fcolor) == '#000000' ? '#000000' : this.fcolor);
		doc.setFontSize(18);
		var name_company = this.splitText(invoiceData.seller.name, 77);
		name_company = doc.splitTextToSize(name_company, doc.internal.pageSize.width - margin * 2 - widthFirstColumn);
		client_space += doc.getTextDimensions(name_company).h + 3;
		var infoInvoice = [];
		doc.setFont("helvetica", 'normal', 'bold');

		var origin = client_space;
		const max_width_second = 'Número: xxxxxxxxxxxxxxxxx';
		const margin_right = doc.internal.pageSize.width - margin + margin / 3;
		var countSpace = 0;
		var tempGap = 7;
		doc.setFontSize(24);
		doc.setTextColor(this.getContrastColor(this.fcolor) == "#ffffff" ? this.fcolor : '#000000');
		var temp_title_margin = (doc.internal.pageSize.width - widthFirstColumn - margin) / 2;
		this.putText(doc, null, this.titlesIn[invoiceData.type], widthFirstColumn + temp_title_margin + margin, margin, 'center', 'nunito', 24);
		doc.setFontSize(12);
		doc.setTextColor('#000');
		var configuration = new ConfigurationPage();
		configuration.margin = new ConfigurationMarginPage(margin, space_for_data_bottom + 30, margin, 0);
		configuration.startY = startYMargin;
		autoTable(doc, {
			startY: startYMargin,
			theme: 'striped',
			bodyStyles: { cellPadding: 7, fontSize: this.fontSizeTBody },
			headStyles: { cellPadding: 7, halign: 'center', fontSize: this.fontSizeTHead },
			tableLineColor: this.tcolor,
			columnStyles: this.getColumnStylesForTemplates(invoiceData, doc.internal.pageSize.width, true),
			margin: { top: margin, right: 0, left: margin, bottom: space_for_data_bottom + 30 },
			head: this.getColumnsByInvoiceType(invoiceData, true),
			body: itemsArray,
			didParseCell: (data) => {
				data.cell.styles.halign = 'center';
				if (data.section === 'body') {
					if (data.column.index == 0) {
						data.cell.styles.fillColor = this.scolor;
					} else {
						data.cell.styles.fillColor = 'white';
					}
				} else if (data.section === 'head') {
					data.cell.styles.fillColor = this.scolor;
				}
				this.dontWrapNumber(data, invoiceData);
			},
			didDrawCell: (data) => {
				if (data.column.index == 0) {
					doc.setFillColor(this.scolor);
					if (data.section === 'head' && data.row.index == 0) {
						doc.roundedRect(data.cell.x - 15, data.cell.y - 15, 15, 15, 5, 5, 'F');
						doc.rect(data.cell.x - 10, data.cell.y - 15, data.cell.width + 10, 15, 'F');
						doc.rect(data.cell.x - 15, data.cell.y - 10, 15, 10 + data.cell.height, 'F');
					} else {
						doc.rect(data.cell.x - 15, data.cell.y, 15, data.cell.height, 'F');
					}
					if (data.section === 'body') {
						doc.roundedRect(data.cell.x - 15, data.cell.y, 15, 15 + data.cell.height, 5, 5, 'F');
						doc.rect(data.cell.x - 10, data.cell.y + data.cell.height, data.cell.width + 10, 15, 'F');
					}
				}
				if (data.section === 'body') {
					doc.setDrawColor(this.tcolor); // set the border color
					doc.setLineWidth(1); // set the border with
					doc.line(
						data.cell.x - 1,
						Math.floor(data.cell.y) + Math.floor(data.cell.height),
						data.cell.x + data.cell.width + 1,
						Math.floor(data.cell.y) + Math.floor(data.cell.height)
					);
				}

			},
			willDrawPage: (HookData) => {
				var origin = doc.internal.pageSize.height - margin;
				var position = doc.internal.pageSize.width - margin + margin / 3;
				doc.setFillColor(this.scolor);
				doc.rect(0, origin - 20, doc.internal.pageSize.width, doc.internal.pageSize.height - origin + 20, 'F');
				doc.setFillColor(this.fcolor);
				doc.rect(0, 0, margin + widthFirstColumn, doc.internal.pageSize.height, 'F');
				var startClientX = margin * 2 + 25;
				var startClientY = client_space;
				const limitClient = 50;
				const fontClient = 12;
				if (HookData.pageNumber == 1) {
					if (logo) {
						var width = widthFirstColumn;
						var height = width * logo.h / logo.w;
						doc.addImage(logo.logo, "JPEG", margin / 2, margin, width, height, 'FAST');
					}
					var y = doc.internal.pageSize.height / 4 - 20;
					doc.setTextColor(this.fcolor);
					doc.setFontSize(16);
					var name = doc.splitTextToSize(invoiceData.seller.name, doc.internal.pageSize.width - startClientX - configuration.margin.right - 25);
					this.putText(doc, null,
						name[0] + (name.length > 1 ? '...' : '')
						,
						startClientX, startClientY, "left", "helvetica", 16);
					startClientY += doc.getTextDimensions('bq').h + 5
					if (invoiceData.type != InvoiceType.INVENTORY) {
						if (invoiceData.type != InvoiceType.TRANSFER) {
							this.putText(doc,
								invoiceData.client.name.toUpperCase().substring(0, limitClient) + (invoiceData.client.name.length > limitClient ? "..." : ""),
								invoiceData.type == InvoiceType.PROVIDER ? "PROVEEDOR: " : "CLIENTE: ", startClientX, startClientY, "left", "helvetica", fontClient);
						} else {
							this.putText(doc,
								invoiceData.carrier.name.toUpperCase().substring(0, limitClient) + (invoiceData.carrier.name.length > limitClient ? "..." : ""),
								"TRANSPORTISTA: ", startClientX, startClientY, "left", "helvetica", fontClient);
						}
						startClientY += doc.getTextDimensions('bq').h + 1;
						if (invoiceData.type != InvoiceType.TRANSFER) {
							this.putText(doc,
								invoiceData.client.address.toUpperCase().substring(0, limitClient) + (invoiceData.client.address.length > 55 ? "..." : ""),
								"DIRECCIÓN: ", startClientX, startClientY, "left", "helvetica", fontClient);
						} else {
							this.putText(doc,
								invoiceData.carrier.destination.toUpperCase().substring(0, limitClient) + (invoiceData.carrier.destination.length > 55 ? "..." : ""),
								"DESTINO: ", startClientX, startClientY, "left", "helvetica", fontClient);
						}
						startClientY += doc.getTextDimensions('bq').h + 1;
						if (invoiceData.type != InvoiceType.TRANSFER) {
							this.putText(doc, invoiceData.client.nit, "NIT: ", startClientX, startClientY, "left", "helvetica", fontClient);
						} else {
							this.putText(doc, invoiceData.carrier.description, "DESCRIPCIÓN: ", startClientX, startClientY, "left", "helvetica", fontClient);
						}
						startClientY += doc.getTextDimensions('bq').h + 5;
						var space = (doc.internal.pageSize.width - startClientX - configuration.margin.right);
						let dateToUse = invoiceData.invoice.accountingDate || invoiceData.invoice.date;
						this.putText(doc, dateToUse, "FECHA: ", startClientX, startClientY, "left", "helvetica", 10);
						if (invoiceData.type != InvoiceType.INVENTORY && invoiceData.type != InvoiceType.PROVIDER && invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.QUOTATION && invoiceData.type != InvoiceType.ADVANCE) {
							this.putText(doc, invoiceData.invoice.number, "NÚMERO: ", startClientX + space / 4, startClientY, "left", "helvetica", 10);
							this.putText(doc, invoiceData.invoice.serial, "SERIE: ", startClientX + space * 2 / 4, startClientY, "left", "helvetica", 10);
							this.putText(doc, invoiceData.seller.nit, "NIT: ", startClientX + space * 3 / 4, startClientY, "left", "helvetica", 10);
						}
						if (invoiceData.type == InvoiceType.QUOTATION) {
							this.putText(doc, invoiceData.invoice.number, "COTIZACIÓN NO: ", startClientX + space * 2 / 4, startClientY, "left", "helvetica", 10);
						}

						if (invoiceData.type == InvoiceType.TRANSFER) {
							this.putText(doc, invoiceData.carrier.plate, "PLACA: ", startClientX + space * 2 / 4, startClientY, "left", "helvetica", 10);
						}

					} else {
						startClientY += 8;
						this.putText(doc, invoiceData.inventory.warehouse.toUpperCase().substring(0, 50) + (invoiceData.inventory.warehouse.length > 50 ? "..." : ""),
							"BODEGA: ", startClientX, startClientY, "left", "helvetica", fontClient);
						startClientY += doc.getTextDimensions('bq').h + 3;
						this.putText(doc, invoiceData.inventory.name.toUpperCase().substring(0, 55) + (invoiceData.inventory.name.length > 55 ? "..." : ""),
							"REALIZADOR: ", startClientX, startClientY, "left", "helvetica", fontClient);
						startClientY += doc.getTextDimensions('bq').h + 3;
						this.putText(doc, invoiceData.inventory.date,
							"FECHA: ", startClientX, startClientY, "left", "helvetica", fontClient);
						startClientY += doc.getTextDimensions('bq').h + 3;
					}
				}
			},
			didDrawPage: (HookData) => {
				if (HookData.pageNumber == 1) {
					var heightBottom = 0;
					doc.setFontSize(10);
					var tempColor = this.scolor;
					var claro = false;
					if (this.getContrastColor(tempColor) == '#000000') {
						claro = true;
					} else {
						claro = false;
					}
					doc.setTextColor(this.getContrastColor(this.fcolor) == '#000000' ? (!claro) ? tempColor : '#000000' : (claro) ? tempColor : '#ffffff');
					var startBottom = doc.internal.pageSize.height - space_for_data_bottom;
					var widthBottom = widthFirstColumn + margin;
					var spaceLeft = 10;
					if (invoiceData.type == InvoiceType.TRANSFER || invoiceData.type == InvoiceType.PROVIDER) {
						spaceLeft = widthFirstColumn + margin + 15;
						widthBottom = doc.internal.pageSize.width - spaceLeft - 15;
						startBottom = doc.internal.pageSize.height - 47;
						doc.setTextColor(this.fcolor);
					}
					var addressText = invoiceData.warehouse && invoiceData.warehouse.address ? invoiceData.warehouse.address : 'Ciudad';
					var splitAddress = doc.splitTextToSize(this.splitText(addressText, 77), widthBottom - 10);
					doc.text(spaceLeft, startBottom + heightBottom, splitAddress);
					heightBottom += doc.getTextDimensions(splitAddress).h + 5;

					var splitPhone = doc.splitTextToSize((invoiceData['warehouse'].name) ? invoiceData['warehouse'].name : '', widthBottom - 10);
					doc.text(spaceLeft, startBottom + heightBottom, splitPhone);
					heightBottom += doc.getTextDimensions(splitPhone).h + 5;
					var splitWeb = doc.splitTextToSize((invoiceData['warehouse'].number) ? "Tel. " + invoiceData['warehouse'].number : '', widthBottom - 10);
					doc.text(spaceLeft, startBottom + heightBottom, splitWeb) + 5;

					var heightBottomTotal = (doc.internal.pageSize.height - startBottom - margin) / 4;

					if (this.addTotal(invoiceData)) {

						const total_data = [
							'TOTAL',
							invoiceData.total
						];

						total_data[1] = this.getNumberLikeMoneyCurrency(
							total_data[1],
							invoiceData.currency
						);

						const total_advance = [
							'ANTICIPO',
							invoiceData.totalAdvance ?? 0
						];

						total_advance[1] = this.getNumberLikeMoneyCurrency(
							total_advance[1],
							invoiceData.currency
						);

						doc.setFontSize(9);

						var phrase = (invoiceData.phrase)
							? invoiceData.phrase
							: 'SUJETO A PAGOS TRIMESTRALES';

						doc.setFillColor(this.tcolor);
						doc.setFontSize(11);
						doc.setDrawColor(this.fcolor);

						var temporalMargin = margin - margin / 3;

						const rightX = doc.internal.pageSize.width - temporalMargin;

						// ============================
						// ANTICIPO
						// ============================
						if (invoiceData.type === InvoiceType.ADVANCE) {

							// Ancho fijo para que TOTAL ANTICIPO se vea correctamente
							const boxWidth = 180;
							const boxX = rightX - boxWidth;

							const rowHeight = doc.getTextDimensions('bp').h + 8;
							const boxHeight = rowHeight * 2;

							// Fondo
							doc.roundedRect(
								boxX,
								startBottom + heightBottomTotal - 10,
								boxWidth,
								boxHeight,
								5,
								5,
								'F'
							);

							// Para mantener la parte derecha cuadrada como tu diseño original
							doc.rect(
								boxX + 5,
								startBottom + heightBottomTotal - 10,
								boxWidth - 5,
								boxHeight,
								'F'
							);

							const totalY = startBottom + heightBottomTotal + 2;
							const advanceY = totalY + rowHeight;

							// ============================
							// TOTAL
							// ============================
							doc.setTextColor('white');
							doc.setFont("helvetica", 'normal', 'bold');

							doc.text(
								total_data[0],
								boxX + 5,
								totalY,
								{ align: 'left' }
							);

							doc.setFont("helvetica", 'normal', 'normal');

							doc.text(
								total_data[1],
								rightX - 5,
								totalY,
								{ align: 'right' }
							);

							// ============================
							// TOTAL ANTICIPO
							// ============================
							doc.setFont("helvetica", 'normal', 'bold');

							doc.text(
								total_advance[0],
								boxX + 5,
								advanceY,
								{ align: 'left' }
							);

							doc.setFont("helvetica", 'normal', 'normal');

							doc.text(
								total_advance[1],
								rightX - 5,
								advanceY,
								{ align: 'right' }
							);

						} else {

							// ============================
							// COMPORTAMIENTO NORMAL
							// ============================

							var textWidth = doc.getTextWidth(phrase);

							doc.roundedRect(
								doc.internal.pageSize.width - temporalMargin - textWidth,
								startBottom + heightBottomTotal - 10,
								temporalMargin + textWidth,
								doc.getTextDimensions('bp').h + 10,
								5,
								5,
								'F'
							);

							doc.rect(
								doc.internal.pageSize.width - temporalMargin - textWidth + 5,
								startBottom + heightBottomTotal - 10,
								temporalMargin + textWidth - 5,
								doc.getTextDimensions('bp').h + 10,
								'F'
							);

							doc.setTextColor('white');
							doc.setFont("helvetica", 'normal', 'bold');

							doc.text(
								total_data[0],
								doc.internal.pageSize.width - temporalMargin - textWidth + 5,
								startBottom + heightBottomTotal + 2,
								{ align: 'left' }
							);

							doc.setFont('helvetica', 'normal', 'normal');

							doc.text(
								total_data[1],
								doc.internal.pageSize.width - temporalMargin - 5,
								startBottom + heightBottomTotal + 2,
								{ align: 'right' }
							);

							// La frase fiscal no se muestra para anticipos
							doc.setTextColor('black');
							doc.setFontSize(9);
							doc.setFont("helvetica", 'normal', 'bold');
							doc.setTextColor(this.tcolor);

							doc.text(
								phrase,
								doc.internal.pageSize.width - temporalMargin + 5,
								startBottom + heightBottomTotal + doc.getTextDimensions('bp').h + 10,
								{ align: 'right' }
							);
						}
					}
					if (invoiceData.type == InvoiceType.QUOTATION) {
						const x = margin + 75;
						const y = doc.internal.pageSize.height - margin + 3;
						const maxW = doc.internal.pageSize.width - margin - 75;

						doc.setFontSize(15);
						doc.setTextColor(this.fcolor);
						doc.setFont("nunito", "normal", "bold");

						const msgLines = doc.splitTextToSize(this.quotationMessage, maxW);
						this.putText(doc, null, msgLines, x, y, 'left', 'nunito', 15);

						doc.setFontSize(11);
						doc.setFont("nunito", "normal", "normal");

						const validityLines = doc.splitTextToSize(this.quotationValidity, maxW);
						const y2 = y + doc.getTextDimensions(msgLines).h + 4;

						this.putText(doc, null, validityLines, x, y2, 'left', 'nunito', 11);
						}

					if (invoiceData.type == InvoiceType.INVENTORY) {
						doc.setTextColor(this.fcolor);
						doc.setDrawColor(this.fcolor);
						this.putInventorySigns(doc, doc.internal.pageSize.height - 110, false);
					}
				}

				var data = [
					invoiceData.certifier.signature,
					'Fecha Certificación: ' + invoiceData.certifier.date,
					'Datos Cetificador: ' + invoiceData.certifier.data + ' NIT: ' + invoiceData.certifier.nit,
					'DOCUMENTO TRIBUTARIO ELECTRÓNICO'
				]
				var origin = doc.internal.pageSize.height - margin;
				var position = doc.internal.pageSize.width - margin + margin / 3;

				if (invoiceData.type == InvoiceType.FCAM) {
						this.putFcamProtest(
							doc,
							invoiceData,
							20,
							doc.internal.pageSize.height - 92,
							300,
							'left',
							'helvetica',
							5,
							'black'
						);
					}

				var footerNumber: string = 'Pagina ' + HookData.pageNumber;
				var tempSpace = 0;
				var gap = 2;
				doc.setFontSize(10);
				doc.setTextColor('white');
				if (invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM)
					for (let i = 0; i < data.length && invoiceData.total >= 0; i++) {
						const element = data[i];
						if (i == data.length - 1) {
							doc.setFontSize(12);
							doc.setFont("helvetica", 'normal', 'bold');
						}
						doc.text(element, position, origin + tempSpace, { align: 'right' });
						if (i != data.length - 1)
							tempSpace += doc.getTextDimensions('bp').h + gap;
					}
				//doc.text(footerNumber, (margin + widthFirstColumn) / 2, origin + tempSpace, { align: 'center' });
			}
		})
		var pageCount = doc.internal.getNumberOfPages(); //Total Page Number
		for (var i = 0; i < pageCount; i++) {
			doc.setFontSize(12);
			doc.setTextColor(this.scolor);
			doc.setFont("helvetica", 'normal', 'bold');
			doc.setPage(i);
			let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
			doc.text('Página ' + pageCurrent + '/' + pageCount, (margin + widthFirstColumn) / 2, doc.internal.pageSize.height - 25, { align: 'center' });
		}
		return this.finalizePDF(invoiceData, doc, 5);
	}

	addTotal(invoiceData) {
		return invoiceData.type != InvoiceType.INVENTORY && invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.PROVIDER;
	}

	async template4(invoiceData, logo) {
		const doc = this.initializePDFLetter();
		const itemsArray = this.getItems(invoiceData);
		await this.getSVG('template4v2');
		const svgElement = this.testSvg;
		const margin = 25;
		this.processSvgAndAddToDoc(svgElement, doc, 4).then(() => {
			const startYMargin = doc.internal.pageSize.height / 3;
			doc.setFont("helvetica", 'normal', 'bold');
			var data = [
				'Número de autorizacion:',
				invoiceData.certifier.signature.split('Número de autorización: ')[1],
				'Fecha Certificación:',
				invoiceData.certifier.date,
				'Datos Cetificador:',
				invoiceData.certifier.data + ' NIT: ' + invoiceData.certifier.nit,
				'DOCUMENTO TRIBUTARIO ELECTRÓNICO'
			]
			var space_for_data_bottom = this.addTotal(invoiceData) || invoiceData.type == InvoiceType.INVENTORY ? 140 : 60;
			var origin_data_fac = doc.internal.pageSize.height - space_for_data_bottom;
			doc.setFillColor(this.fcolor);
			doc.rect(310, 20,
				115, 50, 'F');
			var fontSize = 20;
			doc.setFontSize(fontSize);
			doc.setTextColor("white");
			switch (invoiceData.type) {
				case InvoiceType.NORMAL:
					{
						this.putText(doc, null, "FACTURA", 365, 35, 'center', 'nunito', 28);
						this.putText(doc, "ELECTRONICA", null, 365, 50, 'center', 'nunito', 20);
						break;
					}
				case InvoiceType.FCAM:
					{
						this.putText(doc, null, "FACTURA", 365, 35, 'center', 'nunito', 28);
						this.putText(doc, "ELECTRONICA CAMBIARIA", null, 365, 50, 'center', 'nunito', 20);
						break;
					}
				case InvoiceType.NCRE:
					{
						this.putText(doc, null, "NOTA DE CRÉDITO", 365, 35, 'center', 'nunito', 28);
						this.putText(doc, "ELECTRONICA", null, 365, 50, 'center', 'nunito', 20);
						break;
					}

				case InvoiceType.BACKEND:
					{
						this.putText(doc, null, "DOCUMENTO", 365, 35, 'center', 'nunito', 20.5);
						this.putText(doc, "ELECTRONICO", null, 365, 50, 'center', 'nunito', 20);
						break;
					}

				case InvoiceType.PROVIDER:
					{
						this.putText(doc, null, "ORDEN", 364, 35, 'center', 'nunito', 32);
						this.putText(doc, "DE COMPRA", null, 365, 50, 'center', 'nunito', 20);
						break;
					}

				case InvoiceType.INVENTORY:
					{
						this.putText(doc, null, "REALIZACIÓN", 364, 35, 'center', 'nunito', 22);
						this.putText(doc, "DE INVENTARIO", null, 365, 50, 'center', 'nunito', 20);
						break;
					}


				default:
					{
						this.putText(doc, null, this.titlesIn[invoiceData.type], 366, 45, 'center', 'nunito', 28);
						break;
					}
			}
			var tempSpace = 0;
			var gap = 2;
			doc.setFontSize(10);
			var tempSpaceX = 0;
			var tempColor = this.scolor;
			var claro = false;
			if (this.getContrastColor(tempColor) == '#000000') {
				claro = true;
			} else {
				claro = false;
			}
			doc.setTextColor(this.getContrastColor(this.fcolor) == '#000000' ? (!claro) ? tempColor : '#000000' : (claro) ? tempColor : '#ffffff');
			if (invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE ||  invoiceData.type == InvoiceType.FCAM) {
				for (let i = 0; i < data.length && invoiceData.total >= 0; i++) {
					const element = data[i];
					if (i == 1 || i == 3 || i == 5 || i == 6) {
						doc.setFont("helvetica", 'normal', 'bold');
						if (i == 6) {
							tempSpace += 5;
							tempSpaceX = 0;
						} else {
							tempSpaceX = 10;
						}
					} else if (i == 0 || i == 2 || i == 4) {
						doc.setFont('helvetica', 'normal', 'normal');
						tempSpaceX = 0;
					}
					var splitTitle = doc.splitTextToSize(element, 165);
					doc.text(margin / 2 + tempSpaceX, origin_data_fac + tempSpace, splitTitle);
					if (i != data.length - 1)
						tempSpace += doc.getTextDimensions(splitTitle).h + gap;
				}
			}
			if (invoiceData.type != InvoiceType.INVENTORY && invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.PROVIDER) {
				const total_data = [
					'TOTAL', invoiceData.total
				]
				total_data[1] = this.getNumberLikeMoneyCurrency(total_data[1], invoiceData.currency);

				doc.setFontSize(9);
				//var textWidth = doc.getTextWidth(invoiceData.phrase);
				var phrase = (invoiceData.phrase) ? invoiceData.phrase : 'SUJETO A PAGOS TRIMESTRALES';
				var phraseSplit = doc.splitTextToSize(phrase, doc.internal.pageSize.width / 2 - margin);
				doc.setFillColor('#efeaf3');
				doc.setFontSize(11);
				var x1 = doc.internal.pageSize.width / 2;
				var y1 = origin_data_fac + 20;
				doc.setDrawColor(0, 0, 0); // set the border color
				doc.setLineWidth(0.5); // set the border withr
				doc.line(
					doc.internal.pageSize.width / 2,
					y1 + doc.getTextDimensions('bp').h,
					doc.internal.pageSize.width - margin,
					y1 + doc.getTextDimensions('bp').h
				);
				doc.setTextColor('black');
				doc.setFont("helvetica", 'normal', 'bold');
				doc.text(total_data[0], x1, origin_data_fac + 22, { align: 'left' });
				doc.setTextColor('gray');
				doc.setFont('helvetica', 'normal', 'normal');
				doc.text(total_data[1], doc.internal.pageSize.width - margin, origin_data_fac + 22, { align: 'right' });
				doc.setTextColor('black');
				doc.setFontSize(9);
				doc.setFont("nunito", 'normal', 'bold');
				if (invoiceData.type == InvoiceType.BACKEND || invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.QUOTATION || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM || invoiceData.type == InvoiceType.ADVANCE) {
					doc.text(phraseSplit,
						(doc.internal.pageSize.width - x1 - margin) / 2 + x1,
						origin_data_fac + 32 + doc.getTextDimensions('bp').h, { align: 'center' });
				}
			}
			if (invoiceData.type != InvoiceType.INVENTORY && invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.PROVIDER) {
				this.putSubsidyBelowTotal(
					doc,
					invoiceData,
					doc.internal.pageSize.width - margin,
					origin_data_fac + 55,
					'right',
					'helvetica',
					this.fcolor,
					1
				);
				this.putRegularTextBelowTotal(
					doc,
					invoiceData,
					doc.internal.pageSize.width - margin,
					origin_data_fac + 55,
					'right',
					'helvetica',
					this.fcolor,
					1
				);
			}
			if (invoiceData.type == InvoiceType.FCAM) {
				this.putFcamProtest(
					doc,
					invoiceData,
					doc.internal.pageSize.width / 2,
					origin_data_fac + 48,
					190,
					'left',
					'helvetica',
					4.1,
					'black'
				);
			}
			doc.setFont("helvetica", "normal", "normal");
			var configurations = new ConfigurationPage();
			configurations.margin = new ConfigurationMarginPage(margin * 2, space_for_data_bottom + 10, margin, margin);
			configurations.startY = startYMargin;
			if (invoiceData.type == InvoiceType.INVENTORY) {
				doc.setTextColor(this.fcolor);
				doc.setDrawColor(this.fcolor);
				this.putInventorySigns(doc, doc.internal.pageSize.height - 100, false);
			}
			this.addTable(invoiceData, itemsArray, doc, configurations, null, logo, 4);
			var pageCount = doc.internal.getNumberOfPages(); //Total Page Number

			for (var i = 1; i <= pageCount; i++) {
				doc.setFontSize(11);
				doc.setTextColor((i == 1) ? "white" : this.fcolor);
				doc.setFont("helvetica", 'normal', 'bold');
				doc.setPage(i);
				let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
				var positionX = (i == 1) ? (doc.internal.pageSize.width * 4 / 5 - 14) : (doc.internal.pageSize.width / 2);
				var positionY = (i == 1) ? margin * 3 : margin;
				doc.text('Página ' + pageCurrent + '/' + pageCount, positionX, positionY, { align: 'center', baseline: 'middle' });
			}
			return this.finalizePDF(invoiceData, doc, 4);
		})
	}

	initializePDFLetter() {
		const doc = new jsPDF('p', 'px', 'letter') as any;
		doc.addFileToVFS("Nunito-normal.ttf", this.nunitoNormal);
		doc.addFileToVFS("Nunito-bold.ttf", this.nunitoBold);
		doc.addFont("Nunito-normal.ttf", "nunito", "normal");
		doc.addFont("Nunito-bold.ttf", "nunito", "bold");
		return doc;
	}

	template3(invoiceData: any, logo: any) {
		const doc = this.initializePDFLetter();
		const itemsArray = this.getItems(invoiceData);
		const margin = 35;
		const startYMargin = doc.internal.pageSize.height / 3;
		var space_for_data_bottom = 460;
		var originY_title_invoice = doc.internal.pageSize.height / 8;
		var textH_title_invoice = doc.getTextDimensions('bp').h;
		var configurations = new ConfigurationPage();
		configurations.margin = new ConfigurationMarginPage(margin, (invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.PROVIDER ? 150 : 70), margin, margin);
		configurations.startY = startYMargin;
		doc.setTextColor(this.fcolor);
		doc.setFillColor(this.fcolor);
		doc.rect(0, originY_title_invoice - 15, doc.internal.pageSize.width, textH_title_invoice * 2 + 10, 'F');
		switch (invoiceData.type) {
			case InvoiceType.NORMAL:
				{
					doc.setFontSize(28);
					doc.setFillColor("white");
					doc.rect(355 - doc.getTextWidth("FACTURAS") / 2, originY_title_invoice - 15, doc.getTextWidth("FACTURAS"), textH_title_invoice * 2 + 10, 'F');
					this.putText(doc, null, "FACTURA", 355, 77, 'center', 'nunito', 28);
					this.putText(doc, "ELECTRONICA", null, 355, 92, 'center', 'nunito', 20);
					break;
				}
			
			case InvoiceType.FCAM:
				{
					doc.setFontSize(28);
					doc.setFillColor("white");
					doc.rect(355 - doc.getTextWidth("FACTURAS") / 2, originY_title_invoice - 15, doc.getTextWidth("FACTURAS"), textH_title_invoice * 2 + 10, 'F');
					this.putText(doc, null, "FACTURA", 355, 77, 'center', 'nunito', 28);
					this.putText(doc, "ELECTRONICA", null, 355, 92, 'center', 'nunito', 20);
					this.putText(doc, "CAMBIARIA", null, 355, 107, 'center', 'nunito', 20);
					break;
				}
			
			case InvoiceType.NCRE:
				{
					doc.setFontSize(28);
					doc.setFillColor("white");
					doc.rect(355 - doc.getTextWidth("FACTURAS") / 2, originY_title_invoice - 15, doc.getTextWidth("FACTURAS"), textH_title_invoice * 2 + 10, 'F');
					this.putText(doc, null, "NOTA DE CRÉDITO", 355, 77, 'center', 'nunito', 28);
					this.putText(doc, "ELECTRONICA", null, 355, 92, 'center', 'nunito', 20);
					break;
				}

			case InvoiceType.BACKEND:
				{
					doc.setFontSize(20.5);
					doc.setFillColor("white");
					doc.rect(355 - doc.getTextWidth("DOCUMENTOS") / 2, originY_title_invoice - 15, doc.getTextWidth("DOCUMENTOS"), textH_title_invoice * 2 + 10, 'F');
					this.putText(doc, null, "DOCUMENTO", 355, 77, 'center', 'nunito', 20.5);
					this.putText(doc, "ELECTRONICO", null, 355, 92, 'center', 'nunito', 20);
					break;
				}

			case InvoiceType.PROVIDER:
				{
					doc.setFontSize(32);
					doc.setFillColor("white");
					doc.rect(355 - doc.getTextWidth("ORDENS") / 2, originY_title_invoice - 15, doc.getTextWidth("ORDENS"), textH_title_invoice * 2 + 10, 'F');
					this.putText(doc, null, "ORDEN", 354, 77, 'center', 'nunito', 32);
					this.putText(doc, "DE COMPRA", null, 355, 92, 'center', 'nunito', 20);
					break;
				}

			case InvoiceType.INVENTORY:
				{
					doc.setFontSize(18);
					doc.setFillColor("white");
					doc.rect(346 - doc.getTextWidth("REALIZACIÓNS") / 2, originY_title_invoice - 15, doc.getTextWidth("REALIZACIÓNS"), textH_title_invoice * 2 + 10, 'F');
					this.putText(doc, null, "REALIZACIÓN", 346, 75, 'center', 'nunito', 18);
					this.putText(doc, "DE INVENTARIO", null, 347, 90, 'center', 'nunito', 16);
					break;
				}


			default:
				{
					doc.setFontSize(28);
					doc.setFillColor("white");
					doc.rect(346 - doc.getTextWidth(this.titlesIn[invoiceData.type] + "S") / 2, originY_title_invoice - 15, doc.getTextWidth(this.titlesIn[invoiceData.type] + "S"), textH_title_invoice * 2 + 10, 'F');
					this.putText(doc, null, this.titlesIn[invoiceData.type], 346, 83, 'center', 'nunito', 28);
					break;
				}
		}
		doc.setFontSize(12);
		doc.setTextColor('#000');
		if (logo) {
			var height = 40;
			var width = height * logo.w / logo.h;
			doc.addImage(logo.logo, "JPEG", margin, margin / 4, width, height, 'FAST');
		}
		var heightBottom = 50;
		var startBottom = doc.internal.pageSize.height - (!this.addTotal(invoiceData) ? 65 : 100);
		var widthBottom = doc.internal.pageSize.width / 3;


		var splitPhone = doc.splitTextToSize((invoiceData.warehouse.name) ? invoiceData.warehouse.name : '', widthBottom - 10);
		doc.text(widthBottom / 2, startBottom + heightBottom / 2 - (doc.getTextDimensions(splitPhone).h / 2), splitPhone, { align: 'center', baseline: 'top' });

		var addressText = invoiceData.warehouse && invoiceData.warehouse.address ? invoiceData.warehouse.address : 'Ciudad';
		var splitAddress = doc.splitTextToSize(this.splitText(addressText, 77), widthBottom - 10);
		doc.text(widthBottom + widthBottom / 2, startBottom + (heightBottom / 2) - (doc.getTextDimensions(splitAddress).h) / 2, splitAddress, { align: 'center', baseline: 'top' });

		var splitWeb = doc.splitTextToSize((invoiceData.warehouse.number) ? "Tel. " + invoiceData.warehouse.number : '', widthBottom - 10);
		doc.text(widthBottom * 2 + widthBottom / 2, startBottom + (heightBottom / 2) - (doc.getTextDimensions(splitWeb).h) / 2, splitWeb, { align: 'center', baseline: 'top' });

		doc.setDrawColor(this.tcolor); // set the border color
		doc.setLineWidth(1); // set the border with
		doc.line(
			0,
			startBottom,
			widthBottom * 2.5,
			startBottom
		);
		doc.setLineWidth(1); // set the border with
		doc.line(
			widthBottom / 2,
			startBottom + heightBottom,
			widthBottom * 3,
			startBottom + heightBottom
		);

		doc.setLineWidth(1); // set the border with
		doc.line(
			widthBottom,
			startBottom,
			widthBottom,
			startBottom + heightBottom * 3 / 4
		);

		doc.setLineWidth(1); // set the border with
		doc.line(
			widthBottom * 2,
			startBottom + heightBottom / 4,
			widthBottom * 2,
			startBottom + heightBottom
		);
		const total_data = [
			'TOTAL', invoiceData.total
		]
		if (this.addTotal(invoiceData)) {
			total_data[1] = this.getNumberLikeMoneyCurrency(total_data[1], invoiceData.currency);
			var position_origin = startBottom - 30;
			var total_space = 0;
			doc.setFontSize(9);
			//var textWidth = doc.getTextWidth(invoiceData.phrase);
			var phrase = (invoiceData.phrase) ? invoiceData.phrase : 'SUJETO A PAGOS TRIMESTRALES';
			var textWidth = doc.getTextWidth(phrase);
			doc.setFillColor(this.fcolor);
			doc.setFontSize(11);
			doc.rect(doc.internal.pageSize.width - textWidth - 5, position_origin + total_space - 10,
				textWidth + 5, doc.getTextDimensions('bp').h + 10, 'F');
			doc.setTextColor('white');
			doc.setFont("helvetica", 'normal', 'bold');
			doc.text(total_data[0], doc.internal.pageSize.width - textWidth, position_origin + total_space + 2, { align: 'left' });
			doc.setTextColor('white');
			doc.setFont('helvetica', 'normal', 'normal');
			doc.text(total_data[1], doc.internal.pageSize.width - 5, position_origin + total_space + 2, { align: 'right' });
			this.putSubsidyBelowTotal(
				doc,
				invoiceData,
				doc.internal.pageSize.width - 10,
				position_origin + total_space + 10,
				'right',
				'helvetica',
				'black',
				3
			);
			this.putRegularTextBelowTotal(
				doc,
				invoiceData,
				doc.internal.pageSize.width - 10,
				position_origin + total_space + 10,
				'right',
				'helvetica',
				'black',
				3
			);
			doc.setTextColor('black');
			doc.setFontSize(9);
			doc.setFont("helvetica", 'normal', 'bold');
			doc.setTextColor('black');
			doc.text(phrase, doc.internal.pageSize.width - 5, position_origin + total_space + 10 + doc.getTextDimensions('bp').h, { align: 'right' });
		}
		this.addTable(invoiceData, itemsArray, doc, configurations, null, logo, 3);
		this.addNumberPages(doc, doc.internal.pageSize.width - margin, margin, 'right', this.scolor, 12);
		return this.finalizePDF(invoiceData, doc, 3);
	}

	addNumberPages(doc, positionX, positionY, align, color, fontSize) {
		var pageCount = doc.internal.getNumberOfPages(); //Total Page Number
		for (var i = 0; i < pageCount; i++) {
			doc.setFontSize(fontSize);
			doc.setTextColor(color);
			doc.setFont("helvetica", 'normal', 'bold');
			doc.setPage(i);
			let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
			doc.text('Página ' + pageCurrent + '/' + pageCount, positionX, positionY, { align: align });
		}
	}

	template2(invoiceData: any, logo: any) {
		const doc = this.initializePDFLetter();
		const itemsArray = this.getItems(invoiceData);
		const margin = 30;
		const configurations = new ConfigurationPage();
		configurations.margin = new ConfigurationMarginPage(margin, margin + margin / 2, margin, margin - margin / 3);
		configurations.startY = doc.internal.pageSize.height / 4 + 30;
		var client_data = [
			invoiceData.seller.name,
			(invoiceData.warehouse.name) ? invoiceData.warehouse.name : '',
			invoiceData.warehouse.address ? invoiceData.warehouse.address : '',
			(invoiceData.warehouse.number) ? "Tel. " + invoiceData.warehouse.number : '',
			'',
			''
		]

		var client_space = 0;
		for (let i = 0; i < client_data.length; i++) {
			if (i == 0) {
				doc.setFont("helvetica", 'normal', 'bold');
				doc.setTextColor(this.fcolor);
				doc.setFontSize(11);
			} else {
				doc.setFontSize(8);
				doc.setTextColor('black');
				doc.setFont('helvetica', 'normal', 'normal');
			}
			var parts = doc.splitTextToSize(this.splitText(client_data[i], 60), 190);
			doc.text(parts, margin, doc.internal.pageSize.height / 5 + client_space, { align: 'left' });
			client_space += doc.getTextDimensions(parts).h + 2;
		}
		this.addTable(invoiceData, itemsArray, doc, configurations, null, logo, 2);

		var position_origin = 0;
		if (doc.internal.pageSize.height - margin - doc.lastAutoTable.finalY - margin / 2 <= 30) {
			doc.addPage('p');
			position_origin = doc.internal.pageSize.height / 10;
		} else {
			position_origin = doc.lastAutoTable.finalY + 20;
		}
		const total_data = [
			'TOTAL', invoiceData.total
		]

		total_data[1] = this.getNumberLikeMoneyCurrency(total_data[1], invoiceData.currency);
		if (this.addTotal(invoiceData)) {
			var total_space = 0;
			doc.setFontSize(9);
			//var textWidth = doc.getTextWidth(invoiceData.phrase);
			var phrase = (invoiceData.phrase) ? invoiceData.phrase : 'SUJETO A PAGOS TRIMESTRALES';
			var textWidth = doc.getTextWidth(phrase);
			doc.setFillColor(this.scolor);
			doc.setFontSize(11);
			doc.setDrawColor(this.fcolor);
			var temporalMargin = margin - margin / 3;
			doc.roundedRect(doc.internal.pageSize.width - temporalMargin - textWidth, position_origin + total_space - 10,
				textWidth, doc.getTextDimensions('bp').h + 10, 5, 5, 'FD');
			doc.setTextColor('white');
			doc.setFont("helvetica", 'normal', 'bold');
			doc.text(total_data[0], doc.internal.pageSize.width - temporalMargin - textWidth + 5, position_origin + total_space + 2, { align: 'left' });
			doc.setTextColor('white');
			doc.setFont('helvetica', 'normal', 'normal');
			doc.text(total_data[1], doc.internal.pageSize.width - temporalMargin - 5, position_origin + total_space + 2, { align: 'right' });
			this.putSubsidyBelowTotal(
				doc,
				invoiceData,
				doc.internal.pageSize.width - temporalMargin - 5,
				position_origin + total_space + 10,
				'right',
				'helvetica',
				this.scolor,
				2
			);
			this.putRegularTextBelowTotal(
				doc,
				invoiceData,
				doc.internal.pageSize.width - temporalMargin - 5,
				position_origin + total_space + 10,
				'right',
				'helvetica',
				this.scolor,
				2
			);
			doc.setTextColor('black');
			doc.setFontSize(9);
			doc.setFont("helvetica", 'normal', 'bold');
			doc.setTextColor(this.scolor);
			doc.text(phrase, doc.internal.pageSize.width - temporalMargin, position_origin + total_space + 10 + doc.getTextDimensions('bp').h, { align: 'right' });
		}
		if (invoiceData.type == InvoiceType.INVENTORY) {
			doc.setTextColor(this.fcolor);
			this.putInventorySigns(doc, position_origin + 10);
		}
		if (invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM) {
			this.addNumberPages(doc, margin, doc.internal.pageSize.height - margin / 2, 'left', 'white', 11);
		} else {
			this.addNumberPages(doc, margin, doc.internal.pageSize.height - margin / 2, 'left', this.fcolor, 11);
		}
		return this.finalizePDF(invoiceData, doc, 2);
	}

	getNumberLikeMoneyCurrency(numberToCurrency, currency) {
		if (currency) {
			return numberToCurrency.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
		} else {
			return numberToCurrency.toLocaleString('es-GT', { style: 'currency', currency: 'GTQ' });
		}
	}

	addTable(invoiceData: InvoiceTemplateModel, itemsArray, doc, configuration: ConfigurationPage, imgLoaded, logo, noTemplate) {
		autoTable(doc, {
			startY: configuration.startY,
			theme: 'striped',
			columnStyles: this.getColumnStylesForTemplates(invoiceData, doc.internal.pageSize.width - configuration.margin.left - configuration.margin.right),
			bodyStyles:
			{
				fontSize: this.fontSizeTBody
			},
			headStyles:
			{
				fillColor: this.fcolor,
				halign: 'center',
				fontSize: this.fontSizeTHead
			},
			alternateRowStyles:
			{
				fillColor: this.tcolor
			},
			tableLineWidth: 1,
			tableLineColor: this.tcolor,
			margin:
			{
				top: configuration.margin.top,
				left: configuration.margin.left,
				right: configuration.margin.right,
				bottom: configuration.margin.bottom
			},
			head: this.getColumnsByInvoiceType(invoiceData),
			body: itemsArray,
			didParseCell: (data) => {
				if (data.column.index !== 0) {
					data.cell.styles.halign = 'center';
				} else {
					if (!this.addTotal(invoiceData)) {
						data.cell.styles.halign = 'center';
					}
				}
				if (noTemplate == 4) {
					if (data.section === 'body') {
						if (data.row.index % 2 == 0) {
							data.cell.styles.fillColor = "white";
						} else {
							data.cell.styles.fillColor = this.scolor;
							data.cell.styles.textColor = this.getContrastColor(this.scolor);
						}
					} else {
						data.cell.styles.textColor = this.getContrastColor(this.fcolor);
					}
				}
				this.dontWrapNumber(data, invoiceData);
			},
			didDrawCell: (data: CellHookData) => {
				if (noTemplate == 4) {
					if (data.section === 'head')
						doc.setFillColor(this.fcolor);
					else {
						if (data.row.index % 2 == 0) {
							doc.setFillColor('white');
						} else {
							doc.setFillColor(this.scolor);
						}
					}
				}
			}
			,
			willDrawPage: (HookData) => {
				if (imgLoaded) {
					doc.addImage(
						imgLoaded,
						'JPEG',
						0,
						0,
						doc.internal.pageSize.width + 1,
						doc.internal.pageSize.height + 1,
						'NONE'
					);
				}
				var startClientX = noTemplate == 1 || noTemplate == 4 || noTemplate == 3 ? configuration.margin.left : doc.internal.pageSize.width / 2;
				var startClientY = noTemplate == 1 || noTemplate == 4 || noTemplate == 3 ? doc.internal.pageSize.height / 4 - 20 : doc.internal.pageSize.height / 5;
				const limitClient = noTemplate == 1 || noTemplate == 4 || noTemplate == 3 ? 55 : 35;
				const fontClient = noTemplate == 1 || noTemplate == 4 || noTemplate == 3 ? 12 : 10;
				if (HookData.pageNumber == 1) {
					var y = doc.internal.pageSize.height / 4 - 20;
					doc.setTextColor(this.fcolor);
					var invoiceType = this.titlesIn[invoiceData.type];
					if (noTemplate == 1 || noTemplate == 2) {
						this.putText(doc, null, invoiceType, startClientX, startClientY, "left", "helvetica", 16);
					} else {
						doc.setFontSize(16);
						var name = doc.splitTextToSize(invoiceData.seller.name, doc.internal.pageSize.width - configuration.margin.left - configuration.margin.right - 5);
						const nameValue = name[0]?.trim() ? name[0] + (name.length > 1 ? '...' : '') : '...';
						this.putText(doc, null,
							nameValue
							,
							startClientX, startClientY, "left", "helvetica", 16);
					}
					startClientY += doc.getTextDimensions('bq').h + 5
					if (invoiceData.type != InvoiceType.INVENTORY) {
						if (invoiceData.type != InvoiceType.TRANSFER) {
							this.putText(doc,
								invoiceData.client.name.toUpperCase().substring(0, limitClient) + (invoiceData.client.name.length > limitClient ? "..." : ""),
								invoiceData.type == InvoiceType.PROVIDER ? "PROVEEDOR: " : "CLIENTE: ", startClientX, startClientY, "left", "helvetica", fontClient);
						} else {
							this.putText(doc,
								invoiceData.carrier.name.toUpperCase().substring(0, limitClient) + (invoiceData.carrier.name.length > limitClient ? "..." : ""),
								"TRANSPORTISTA: ", startClientX, startClientY, "left", "helvetica", fontClient);
						}
						startClientY += doc.getTextDimensions('bq').h + 1;
						if (invoiceData.type != InvoiceType.TRANSFER) {
							this.putText(doc,
								invoiceData.client.address.toUpperCase().substring(0, limitClient) + (invoiceData.client.address.length > 55 ? "..." : ""),
								"DIRECCIÓN: ", startClientX, startClientY, "left", "helvetica", fontClient);
						} else {
							this.putText(doc,
								invoiceData.carrier.destination.toUpperCase().substring(0, limitClient) + (invoiceData.carrier.destination.length > 55 ? "..." : ""),
								"DESTINO: ", startClientX, startClientY, "left", "helvetica", fontClient);
						}
						startClientY += doc.getTextDimensions('bq').h + 1;
						if (invoiceData.type != InvoiceType.TRANSFER) {
							this.putText(doc, invoiceData.client.nit, "NIT: ", startClientX, startClientY, "left", "helvetica", fontClient);
						} else {
							this.putText(doc, invoiceData.carrier.description, "DESCRIPCIÓN: ", startClientX, startClientY, "left", "helvetica", fontClient);
							startClientY += doc.getTextDimensions('bq').h + 1;
							this.putText(doc, invoiceData.carrier.plate, "PLACA: ", startClientX, startClientY, "left", "helvetica", fontClient);
						}

						if (noTemplate == 1 || noTemplate == 4 || noTemplate == 3) {
							startClientY += doc.getTextDimensions('bq').h + 5;
							var space = doc.internal.pageSize.width - (2 * configuration.margin.left - configuration.margin.left / 3);
							let dateToUse = invoiceData.invoice.accountingDate || invoiceData.invoice.date;
							this.putText(doc, dateToUse, "FECHA: ", configuration.margin.left, startClientY, "left", "helvetica", 10);
							if (invoiceData.type != InvoiceType.INVENTORY && invoiceData.type != InvoiceType.PROVIDER && invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.QUOTATION && invoiceData.type != InvoiceType.ADVANCE) {
								this.putText(doc, invoiceData.invoice.number, "NÚMERO: ", configuration.margin.left + space / 4, startClientY, "left", "helvetica", 10);
								this.putText(doc, invoiceData.invoice.serial, "SERIE: ", configuration.margin.left + space * 2 / 4, startClientY, "left", "helvetica", 10);
								this.putText(doc, invoiceData.seller.nit, "NIT: ", configuration.margin.left + space * 3 / 4, startClientY, "left", "helvetica", 10);
							}
							if (invoiceData.type == InvoiceType.QUOTATION) {
								const QUOTATION_OFFSET_Y = -10;
								this.putText(doc,invoiceData.invoice.number,"COTIZACIÓN NO: ",configuration.margin.left,startClientY + 10,"left","helvetica",10);
								doc.setFont("helvetica", "normal", "normal");
								doc.setFontSize(12);
								const boxX = configuration.margin.left + space / 4 + 20;
								const boxY = startClientY - 20 + QUOTATION_OFFSET_Y;
								const spaceForText = doc.internal.pageSize.width - configuration.margin.left - configuration.margin.right - space / 4 - 20;
								const fixedQuotationMessage = doc.splitTextToSize(this.quotationMessage, spaceForText);
								doc.setFontSize(10);
								const fixedValidityMessage = doc.splitTextToSize(this.quotationValidity, spaceForText);
								const totalTextHeight = doc.getTextDimensions(fixedQuotationMessage).h + 4 + doc.getTextDimensions(fixedValidityMessage).h;

								doc.roundedRect(boxX,boxY,spaceForText + 10,totalTextHeight + 20,5,5,"F");

								doc.setTextColor("white");
								doc.setFontSize(12);
								this.putText(doc,fixedQuotationMessage,null,boxX + 10,(startClientY - 3) + QUOTATION_OFFSET_Y,"left","helvetica",12);

								const yValidity = (startClientY - 3) + doc.getTextDimensions(fixedQuotationMessage).h + 4 + QUOTATION_OFFSET_Y;
								doc.setFontSize(10);
								this.putText(doc,fixedValidityMessage,null,boxX + 10,yValidity,"left","helvetica",10);
							}
						} else {
							startClientY = 30;
							doc.setDrawColor(this.fcolor);
							doc.setFillColor(this.tcolor);
							if (invoiceData.total >= 0) {
								doc.roundedRect(startClientX, startClientY,
									doc.internal.pageSize.width / 2 - configuration.margin.right, 45, 5, 5, 'FD');
							}
							startClientY += 15;
							startClientX += 10;
							let dateToUse = invoiceData.invoice.accountingDate || invoiceData.invoice.date;
							this.putText(doc, dateToUse, "FECHA: ", startClientX, startClientY, "left", "helvetica", 10);
							startClientX += doc.internal.pageSize.width / 4 - configuration.margin.right / 2;
							if (invoiceData.type != InvoiceType.INVENTORY && invoiceData.type != InvoiceType.PROVIDER && invoiceData.type != InvoiceType.TRANSFER && invoiceData.type != InvoiceType.QUOTATION && invoiceData.type != InvoiceType.ADVANCE) {
								this.putText(doc, invoiceData.invoice.number, "NÚMERO: ", startClientX, startClientY, "left", "helvetica", 10);
								startClientX = doc.internal.pageSize.width / 2 + 10;
								startClientY += 20;
								this.putText(doc, invoiceData.invoice.serial, "SERIE: ", startClientX, startClientY, "left", "helvetica", 10);
								startClientX += doc.internal.pageSize.width / 4 - configuration.margin.right / 2;
								this.putText(doc, invoiceData.seller.nit, "NIT: ", startClientX, startClientY, "left", "helvetica", 10);
							}
							if (invoiceData.type == InvoiceType.QUOTATION) {
								this.putText(doc,invoiceData.invoice.number,"COTIZACIÓN NO: ",startClientX - 15,startClientY,"left","helvetica",10);

								startClientX = doc.internal.pageSize.width / 2 + 10;
								startClientY += 20;

								const maxW = doc.internal.pageSize.width - startClientX - 10 - configuration.margin.right;

								const msgLines = doc.splitTextToSize(this.quotationMessage, maxW);
								const yMsg = startClientY - 12;
								this.putText(doc, msgLines, null, startClientX, yMsg, "left", "helvetica", 10);
								const yValidity = yMsg + doc.getTextDimensions(msgLines).h + 3;
								const validityLines = doc.splitTextToSize(this.quotationValidity, maxW);
								this.putText(doc, validityLines, null, startClientX, yValidity, "left", "helvetica", 9);
							}
						}
					} else {
						startClientY += 8;
						this.putText(doc, invoiceData.inventory.warehouse.toUpperCase().substring(0, 50) + (invoiceData.inventory.warehouse.length > 50 ? "..." : ""),
							"BODEGA: ", startClientX, startClientY, "left", "helvetica", fontClient);
						startClientY += doc.getTextDimensions('bq').h + 3;
						this.putText(doc, invoiceData.inventory.name.toUpperCase().substring(0, 55) + (invoiceData.inventory.name.length > 55 ? "..." : ""),
							"REALIZADOR: ", startClientX, startClientY, "left", "helvetica", fontClient);
						startClientY += doc.getTextDimensions('bq').h + 3;
						this.putText(doc, invoiceData.inventory.date,
							"FECHA: ", startClientX, startClientY, "left", "helvetica", fontClient);
						startClientY += doc.getTextDimensions('bq').h + 3;
					}
					if (logo && noTemplate != 3) {
						var height = 80;
						doc.addImage(logo.logo, "JPEG", configuration.margin.left, configuration.margin.left / 2, height, height, 'FAST');
					}
					if (this.dataUrl && noTemplate != 3) {
						var height = 80;
						doc.addImage(this.dataUrl, "PNG", configuration.margin.left, configuration.margin.left / 2, height, height, "FAST");
					}
				}
			},
			didDrawPage: (HookData) => {
				if (noTemplate == 3 && (invoiceData.type == InvoiceType.BACKEND || invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM)) {
					HookData.settings.margin.bottom = configuration.margin.left + 10;
					if (HookData.pageNumber > 1) {
						space_for_data_bottom = configuration.margin.left;
					}
					var data = [
						invoiceData.certifier.signature,
						'Fecha Certificación: ' + invoiceData.certifier.date,
						'Datos Cetificador: ' + invoiceData.certifier.data + ' NIT: ' + invoiceData.certifier.nit,
						'DOCUMENTO TRIBUTARIO ELECTRÓNICO'
					]

					if (invoiceData.type == InvoiceType.FCAM) {
						this.putFcamProtest(
							doc,
							invoiceData,
							20,
							doc.internal.pageSize.height - 140,
							300,
							'left',
							'helvetica',
							5,
							'black'
						);
					}

					var origin = doc.internal.pageSize.height - configuration.margin.left * 5 / 6;
					var position = doc.internal.pageSize.width - configuration.margin.left + configuration.margin.left / 3;
					doc.setFillColor(this.fcolor);
					var tempSpace = 0;
					var gap = 5;
					doc.setFontSize(10);
					doc.setTextColor('gray');
					doc.setFont('helvetica', 'normal', 'normal');
					for (let i = 0; i < data.length; i += 2) {
						var element = data[i + 1];
						var element2 = data[i];
						if (i == 2) {
							element2 = doc.splitTextToSize(element2, doc.internal.pageSize.width - configuration.margin.left * 5 / 3 - doc.getTextWidth(element));
						}
						if (invoiceData.total >= 0)
							doc.text(element2, configuration.margin.left * 2 / 3, origin + tempSpace)
						if (i == 2) {
							doc.setFont("helvetica", 'normal', 'bold');
						}
						if (invoiceData.total >= 0)
							doc.text(element, position, origin + tempSpace, { align: 'right' });
						if (i != data.length - 1)
							tempSpace += doc.getTextDimensions('bp').h + gap;
					}
				}
				if (noTemplate == 4) {
					var space_for_data_bottom = 450;
					HookData.settings.margin.bottom = configuration.margin.left + 30;
					if (HookData.pageNumber > 1) {
						space_for_data_bottom = configuration.margin.left + 30;
					}
					var heightBottom = configuration.margin.left * 2;
					var startBottom = doc.internal.pageSize.height - heightBottom;
					var widthBottom = doc.internal.pageSize.width / 3;
					var ware = (invoiceData.warehouse.name) ? invoiceData.warehouse.name : '';
					var splitPhone = doc.splitTextToSize(this.splitText(ware, 77), widthBottom - 10);
					doc.text(widthBottom / 2, startBottom + heightBottom / 2 - (doc.getTextDimensions(splitPhone).h / 2), splitPhone, { align: 'center' });

					var addressText = invoiceData.warehouse && invoiceData.warehouse.address ? invoiceData.warehouse.address : 'Ciudad';
					var splitAddress = doc.splitTextToSize(this.splitText(addressText, 77), widthBottom - 10);
					doc.text(widthBottom + widthBottom / 2, startBottom + heightBottom / 2 - (doc.getTextDimensions(splitAddress).h / 2), splitAddress, { align: 'center' });

					var splitWeb = doc.splitTextToSize((invoiceData.warehouse.number) ? "Tel. " + invoiceData.warehouse.number : '', widthBottom - 10);
					doc.text(widthBottom * 2 + widthBottom / 2, startBottom + heightBottom / 2 - (doc.getTextDimensions(splitWeb).h / 2), splitWeb, { align: 'center' });
					doc.setDrawColor(this.fcolor);
					doc.setFillColor(this.fcolor);
					doc.line(
						widthBottom,
						startBottom - 18,
						widthBottom,
						doc.internal.pageSize.height - 20
					);

					doc.circle(widthBottom, doc.internal.pageSize.height - 20, 3, 'F');
					doc.circle(widthBottom * 2, startBottom, 3, 'F');
					doc.line(
						widthBottom * 2,
						startBottom,
						widthBottom * 2,
						doc.internal.pageSize.height
					);
				}
				if (HookData.pageNumber == 1 && noTemplate == 3) {
					HookData.settings.margin.bottom = configuration.margin.left + 10;
					if (invoiceData.type == InvoiceType.INVENTORY) {
						doc.setTextColor(this.fcolor);
						doc.setDrawColor(this.fcolor);
						this.putInventorySigns(doc, doc.internal.pageSize.height - 100);
					}
				}
				if ((invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM) && (noTemplate == 1 || noTemplate == 2)) {
					var data = [
						invoiceData.certifier.signature,
						'Fecha Certificación: ' + invoiceData.certifier.date,
						'Datos Cetificador: ' + invoiceData.certifier.data + ' NIT: ' + invoiceData.certifier.nit,
						'DOCUMENTO TRIBUTARIO ELECTRÓNICO'
					]
					if (invoiceData.type == InvoiceType.FCAM) {
						this.putFcamProtest(
							doc,
							invoiceData,
							20,
							doc.internal.pageSize.height - 92,
							300,
							'left',
							'helvetica',
							5,
							'black'
						);
					}

					var origin = doc.internal.pageSize.height - configuration.margin.left;
					var position = doc.internal.pageSize.width - configuration.margin.left + configuration.margin.left / 3;
					var tempSpace = 0;
					var gap = 2;
					if (noTemplate == 2) {
						doc.setFillColor(this.fcolor);
						doc.rect(0, origin - 10, doc.internal.pageSize.width, doc.internal.pageSize.height - origin + 10, 'F');
					}
					doc.setFontSize(10);
					doc.setTextColor('white');
					for (let i = 0; i < data.length; i++) {
						const element = data[i];
						if (i == data.length - 1) {
							doc.setFontSize(12);
							doc.setFont("helvetica", 'normal', 'bold');
						}
						if (invoiceData.total >= 0)
							doc.text(element, position, origin + tempSpace, { align: 'right' });
						if (i != data.length - 1)
							tempSpace += doc.getTextDimensions('bp').h + gap;
					}
				}
			}
		})
	}

	async template1(invoiceData: InvoiceTemplateModel, logo: any) {
		const doc = this.initializePDFLetter();
		const itemsArray = this.getItems(invoiceData);
		await this.getSVG('template1v1');
		const svgElement = this.testSvg;
		//const configuration
		const margin = 45;
		const configurations = new ConfigurationPage();
		configurations.margin = new ConfigurationMarginPage(margin, 100, margin, margin - margin / 3);
		configurations.startY = doc.internal.pageSize.height / 3;
		this.processSvgAndAddToDoc(svgElement, doc, 1).then((imgLoaded) => {
			this.addTable(invoiceData, itemsArray, doc, configurations, imgLoaded, logo, 1);
			const sellerData = [{
				text: invoiceData.seller?.name ? invoiceData.seller?.name : '',
				size: 12,
				bold: true
			}, {
				text: invoiceData.warehouse?.name ? invoiceData.warehouse.name : "",
				size: 11,
				bold: false
			}, {
				text: invoiceData.warehouse?.address ? invoiceData.warehouse.address : "",
				size: 10,
				bold: true
			}, {
				text: invoiceData.warehouse?.number ? invoiceData.warehouse.number + "" : "",
				size: 9,
				bold: true
			}]
			var totalHeightSeller = 0;
			sellerData.forEach((s) => {
				doc.setFont("nunito", "normal", s.bold ? 'bold' : 'normal');
				doc.setFontSize(s.size);
				var tempText = doc.splitTextToSize(this.splitText(s.text, 50), doc.internal.pageSize.width / 2 - configurations.margin.left - 10);
				totalHeightSeller += doc.getTextDimensions(tempText).h + 4;
			})
			var position_origin = 0;
			var original = 0;
			if (invoiceData.type == InvoiceType.INVENTORY) {
				totalHeightSeller = 25;
			}
			if (invoiceData.type !== InvoiceType.PROVIDER && invoiceData.type !== InvoiceType.TRANSFER) {
				if (doc.internal.pageSize.height - configurations.margin.bottom - doc.lastAutoTable.finalY <= totalHeightSeller) {
					doc.addPage('p');
					doc.addImage(
						imgLoaded,
						'JPEG',
						0,
						0,
						doc.internal.pageSize.width + 1,
						doc.internal.pageSize.height + 1,
						'NONE'
					);
					position_origin = doc.internal.pageSize.height / 4;
				} else {
					position_origin = doc.lastAutoTable.finalY + 25;
				}
			}
			original = position_origin;
			const client_data = [
				invoiceData.seller.name,
				(invoiceData.warehouse.name) ? invoiceData.warehouse.name : '',
				invoiceData.warehouse.address,
				(invoiceData.warehouse.number) ? "Tel. " + invoiceData.warehouse.number : ''
			]
			const total_data = [
				'TOTAL', invoiceData.total
			]
			total_data[1] = this.getNumberLikeMoneyCurrency(total_data[1], invoiceData.currency);
			const total_advance = [
				'TOTAL ANTICIPO',
				invoiceData.totalAdvance ?? 0
			];

			total_advance[1] = this.getNumberLikeMoneyCurrency(
				total_advance[1],
				invoiceData.currency
			);
			if (invoiceData.type !== InvoiceType.INVENTORY && invoiceData.type !== InvoiceType.PROVIDER && invoiceData.type !== InvoiceType.TRANSFER && invoiceData.type !== InvoiceType.ADVANCE) {
				doc.setFillColor("white");
				doc.roundedRect(configurations.margin.left - 5, original - 10,
					doc.internal.pageSize.width / 2 - configurations.margin.left - 5, totalHeightSeller + 5, 5, 5, 'F');
				doc.setFont("nunito", "normal", "bold");
				doc.setFontSize(12);
				doc.setTextColor(this.fcolor);
				var text = doc.splitTextToSize(this.splitText(invoiceData.seller.name, 50), doc.internal.pageSize.width / 2 - configurations.margin.left - 10);
				this.putText(doc,
					null, text, configurations.margin.left, position_origin, 'left', "nunito", 12);
				const warehouse = invoiceData.warehouse.name ? invoiceData.warehouse.name : "";
				position_origin += doc.getTextDimensions(text).h + 4;
				text = doc.splitTextToSize(this.splitText(warehouse, 50), doc.internal.pageSize.width / 2 - configurations.margin.left - 10);
				this.putText(doc, text,
					null, configurations.margin.left, position_origin, 'left', "nunito", 10);
				const street = invoiceData.warehouse.address ? invoiceData.warehouse.address : "";
				position_origin += doc.getTextDimensions(text).h + 4;
				text = doc.splitTextToSize(this.splitText(street, 50), doc.internal.pageSize.width / 2 - configurations.margin.left - 10);
				this.putText(doc, text,
					null, configurations.margin.left, position_origin, 'left', "nunito", 10);
				position_origin += doc.getTextDimensions(text).h + 4;
				text = invoiceData.warehouse.number ? invoiceData.warehouse.number + "" : "";
				this.putText(doc, text,
					text ? 'Tel.' : '', configurations.margin.left, position_origin, 'left', "nunito", 10);
				var phrase = (invoiceData.phrase) ? invoiceData.phrase : 'SUJETO A PAGOS TRIMESTRALES';
				position_origin = doc.lastAutoTable.finalY + 25;
				doc.setFontSize(12);
				doc.setFillColor(this.fcolor);
				doc.roundedRect(doc.internal.pageSize.width / 2 + 10, original,
					doc.internal.pageSize.width / 2 - configurations.margin.right - 10, doc.getTextDimensions('HQ').h + 5, 5, 5, 'F');
				doc.setTextColor(this.scolor);
				this.putText(doc, null,
					'TOTAL', doc.internal.pageSize.width / 2 + 20, original + 10, 'left', "nunito", 12);
				this.putText(doc, total_data[1] + "",
					null, doc.internal.pageSize.width - configurations.margin.right - 20, original + 10, 'right', "nunito", 12);
				this.putSubsidyBelowTotal(
					doc,
					invoiceData,
					doc.internal.pageSize.width - configurations.margin.right - 20,
					original + 18,
					'right',
					'nunito',
					this.fcolor,
					1
				);
				this.putRegularTextBelowTotal(
					doc,
					invoiceData,
					doc.internal.pageSize.width - configurations.margin.right - 20,
					original + 18,
					'right',
					'nunito',
					this.fcolor,
					1
				);
				doc.setFontSize(10);
				const phraseSplit = doc.splitTextToSize(phrase, doc.internal.pageSize.width / 2 - configurations.margin.right - 10);
				doc.setTextColor(this.fcolor);
				this.putText(doc, null,
					phraseSplit, (doc.internal.pageSize.width * 3 / 4) - 10, original + 20 + doc.getTextDimensions('HQ').h, 'center', "nunito", 10);
			} else if (invoiceData.type == InvoiceType.INVENTORY) {
				doc.setLineWidth(1);
				position_origin += 12;
				var firstQuarter = doc.internal.pageSize.width / 4;
				doc.line(firstQuarter - 50, position_origin, firstQuarter + 50, position_origin);
				this.putText(doc, null, "FIRMA REALIZADOR", firstQuarter, position_origin + 8, "center", 'helvetica', 10)
				var thridQuarter = doc.internal.pageSize.width * 3 / 4;
				doc.line(thridQuarter - 50, position_origin, thridQuarter + 50, position_origin);
				this.putText(doc, null, "FIRMA ENCARGADO", thridQuarter, position_origin + 8, "center", 'helvetica', 10)
			} else if (invoiceData.type === InvoiceType.ADVANCE) {
				doc.setFillColor("white");

				doc.roundedRect(
					configurations.margin.left - 5,
					original - 10,
					doc.internal.pageSize.width / 2 - configurations.margin.left - 5,
					totalHeightSeller + 5,
					5,
					5,
					'F'
				);

				doc.setFont("nunito", "normal", "bold");
				doc.setFontSize(12);
				doc.setTextColor(this.fcolor);

				let text = doc.splitTextToSize(
					this.splitText(invoiceData.seller.name, 50),
					doc.internal.pageSize.width / 2 - configurations.margin.left - 10
				);

				this.putText(
					doc,
					null,
					text,
					configurations.margin.left,
					position_origin,
					'left',
					"nunito",
					12
				);

				const warehouse = invoiceData.warehouse.name
					? invoiceData.warehouse.name
					: "";

				position_origin += doc.getTextDimensions(text).h + 4;

				text = doc.splitTextToSize(
					this.splitText(warehouse, 50),
					doc.internal.pageSize.width / 2 - configurations.margin.left - 10
				);

				this.putText(
					doc,
					text,
					null,
					configurations.margin.left,
					position_origin,
					'left',
					"nunito",
					10
				);

				const street = invoiceData.warehouse.address
					? invoiceData.warehouse.address
					: "";

				position_origin += doc.getTextDimensions(text).h + 4;

				text = doc.splitTextToSize(
					this.splitText(street, 50),
					doc.internal.pageSize.width / 2 - configurations.margin.left - 10
				);

				this.putText(
					doc,
					text,
					null,
					configurations.margin.left,
					position_origin,
					'left',
					"nunito",
					10
				);

				position_origin += doc.getTextDimensions(text).h + 4;

				text = invoiceData.warehouse.number
					? invoiceData.warehouse.number + ""
					: "";

				this.putText(
					doc,
					text,
					text ? 'Tel.' : '',
					configurations.margin.left,
					position_origin,
					'left',
					"nunito",
					10
				);

				position_origin = doc.lastAutoTable.finalY + 25;

				const boxX = doc.internal.pageSize.width / 2 + 10;

				const boxWidth =
					doc.internal.pageSize.width / 2 -
					configurations.margin.right -
					10;

				const rightX =
					doc.internal.pageSize.width -
					configurations.margin.right -
					20;

				doc.setFontSize(12);

				const rowHeight = doc.getTextDimensions('HQ').h + 7;
				const boxHeight = rowHeight * 2;

				doc.setFillColor(this.fcolor);

				doc.roundedRect(
					boxX,
					original,
					boxWidth,
					boxHeight,
					5,
					5,
					'F'
				);

				const totalY = original + 10;
				const advanceY = totalY + rowHeight;

				// TOTAL
				doc.setTextColor(this.scolor);
				doc.setFont("nunito", "normal", "bold");

				this.putText(
					doc,
					null,
					'TOTAL',
					boxX + 10,
					totalY,
					'left',
					"nunito",
					12
				);

				doc.setFont("nunito", "normal", "normal");

				this.putText(
					doc,
					total_data[1] + "",
					null,
					rightX,
					totalY,
					'right',
					"nunito",
					12
				);

				// TOTAL ANTICIPO
				doc.setFont("nunito", "normal", "bold");

				this.putText(
					doc,
					null,
					'TOTAL ANTICIPO',
					boxX + 10,
					advanceY,
					'left',
					"nunito",
					12
				);

				doc.setFont("nunito", "normal", "normal");

				this.putText(
					doc,
					total_advance[1] + "",
					null,
					rightX,
					advanceY,
					'right',
					"nunito",
					12
				);
			}
			this.addNumberPages(doc, margin - 10, doc.internal.pageSize.height - margin / 2 + 5, 'left', this.scolor, 12);
			return this.finalizePDF(invoiceData, doc, 1);
		})
	}

	putInventorySigns(doc, position_origin, all = true) {
		doc.setLineWidth(1);
		position_origin += 12;
		var firstQuarter = all ? doc.internal.pageSize.width / 4 : doc.internal.pageSize.width * 5 / 9;
		doc.line(firstQuarter - 50, position_origin, firstQuarter + 50, position_origin);
		this.putText(doc, null, "FIRMA REALIZADOR", firstQuarter, position_origin + 8, "center", 'helvetica', 10)
		var thridQuarter = all ? doc.internal.pageSize.width * 3 / 4 : doc.internal.pageSize.width * 8 / 9 - 10;
		doc.line(thridQuarter - 50, position_origin, thridQuarter + 50, position_origin);
		this.putText(doc, null, "FIRMA ENCARGADO", thridQuarter, position_origin + 8, "center", 'helvetica', 10)
	}

	finalizePDF(invoiceData: InvoiceTemplateModel, doc, template): string {
		var string = "";
		delete this.isLoading[invoiceData['id'] ? invoiceData['id'] : template];
		if (this.visor) {
			string = doc.output('datauristring');
			let zoomLevel = 50;
			var embed = `<embed width='100%' height='100%' src='${string}#zoom=${zoomLevel}' />`;
			this.visor.innerHTML = embed;
		} else {
			if (invoiceData.type != InvoiceType.INVENTORY) {
				if (invoiceData.type == InvoiceType.QUOTATION) {
					doc.save("COTIZACION-" + invoiceData.invoice.number + ".pdf");
				}else if (invoiceData.type == InvoiceType.ADVANCE) {
					doc.save("ANTICIPO.pdf");
				} else {
					doc.save(invoiceData.invoice.serial + "-" + invoiceData.invoice.number + ".pdf");
				}
			} else {
				doc.save(`INVENTARIO-${invoiceData.inventory.date}-${invoiceData.inventory.warehouse}.pdf`);
			}
		}
		return string;
	}

	getItems(invoiceData: InvoiceTemplateModel, isTemplate5 = false) {
		if (invoiceData.type != InvoiceType.INVENTORY && invoiceData.type != InvoiceType.TRANSFER) {
			return this.getInvoiceItems(invoiceData, isTemplate5, invoiceData.type == InvoiceType.PROVIDER);
		} else {
			return this.getItemsTransfer(invoiceData, isTemplate5);
		}
	}

	splitText(text, maxLength) {
		if (text.length <= maxLength) {
			return text;
		}

		const cuttedText = text.substring(0, maxLength);
		const lastSpace = cuttedText.lastIndexOf(' ');

		if (lastSpace !== -1 && lastSpace >= maxLength - 3) {
			return cuttedText.substring(0, lastSpace) + '...';
		} else {
			return cuttedText + '...';
		}
	}


	private drawMultiColumnLabeledText(
	doc: any,
	text: string,
	title: string,
	x: number,
	y: number,
	opts?: {
		columns?: number;
		colWidth?: number;
		gap?: number;
		font?: string;
		fz?: number;
		maxLinesPerCol?: number;
		align?: 'left'|'right'|'center';
	}
	) {
	const { columns = 2, colWidth = 36, gap = 4, font = 'helvetica', fz = 7, maxLinesPerCol = 3, align = 'left' } = opts || {};
	if (!text || text.trim().length === 0) return y;

	doc.setFont(font, 'normal');
	doc.setFontSize(fz);

	// Partimos el texto al ancho de UNA columna (sin el título)
	const lines: string[] = doc.splitTextToSize(text, colWidth);

	// Distribuimos líneas por columnas
	const lineH = doc.getTextDimensions("H").h;
	const totalColsNeeded = Math.ceil(lines.length / maxLinesPerCol);
	const colsToDraw = Math.min(columns, Math.max(1, totalColsNeeded));

	let usedLinesThisCol = 0;
	let globalLineIndex = 0;
	let maxLinesDrawn = 0;

	for (let col = 0; col < colsToDraw; col++) {
		const colX = x + col * (colWidth + gap);
		const colY = y;

		// Líneas asignadas a esta columna
		const sliceStart = globalLineIndex;
		const sliceEnd = Math.min(lines.length, sliceStart + maxLinesPerCol);
		const colLines = lines.slice(sliceStart, sliceEnd);
		globalLineIndex = sliceEnd;

		// Dibuja título solo en la primera columna
		if (col === 0) {
		// primera línea con título
		if (colLines.length > 0) {
			this.putText(doc, colLines[0], title, colX, colY, align, font, fz);
		}
		// líneas restantes sin título
		for (let i = 1; i < colLines.length; i++) {
			this.putText(doc, colLines[i], "", colX, colY + lineH * i, align, font, fz);
		}
		} else {
		// todas sin título
		for (let i = 0; i < colLines.length; i++) {
			this.putText(doc, colLines[i], "", colX, colY + lineH * i, align, font, fz);
		}
		}

		usedLinesThisCol = colLines.length;
		maxLinesDrawn = Math.max(maxLinesDrawn, usedLinesThisCol);
	}

	// Devuelve el nuevo "end" (y) avanzado según la columna más alta
	return y + lineH * Math.max(1, maxLinesDrawn);
	}

	private putSubsidyBelowTotal(
		doc: any,
		invoiceData: InvoiceTemplateModel,
		x: number,
		y: number,
		align: 'left' | 'center' | 'right' = 'right',
		font: string = 'helvetica',
		color: any = 'gray',
		template: number = 0,
	) {
		if (
			(invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM) &&
			invoiceData.totalSubsidy &&
			invoiceData.totalSubsidy > 0
		) {
			doc.setTextColor('black');
			doc.setFont(font, 'normal', 'normal');
			doc.setFontSize(7);

			let leftValue = x;
			let heightValue = y;

			if (template == 3 || template == 2 || template == 1) {
				leftValue -= 110;
			}

			if (template == 6) {
				heightValue += 8;
			}

			const totalWithoutSubsidy =
				Number(invoiceData.total || 0) +
				Number(invoiceData.totalSubsidy || 0);

			const text1 =
				`Esta factura incluye apoyo social temporal Decreto 11-2026 por un valor de ${this.getNumberLikeMoneyCurrency(invoiceData.totalSubsidy, invoiceData.currency)}`;

			const text2 =
				`Monto total a pagar sin apoyo social temporal ${this.getNumberLikeMoneyCurrency(totalWithoutSubsidy, invoiceData.currency)}`;

			const maxWidth = 130;

			const lines1 = doc.splitTextToSize(text1, maxWidth);
			const lines2 = doc.splitTextToSize(text2, maxWidth);

			doc.text(lines1, leftValue, heightValue, { align });

			heightValue += lines1.length * 6;

			doc.text(lines2, leftValue, heightValue, { align });
		}
	}
/*
	private putRegularTextBelowTotal(
		doc: any,
		invoiceData: InvoiceTemplateModel,
		x: number,
		y: number,
		align: 'left' | 'center' | 'right' = 'right',
		font: string = 'helvetica',
		color: any = 'gray',
		template: number = 0,
	) {
		if (
			(invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM) &&
			invoiceData.hasRegularExtraTax
		) {
			// NOTA: Esta parte se agrego despues del subsidio aunque se sobre pone a el, para que los dos queden en funcionamiento 
			// Habria que modificar que este texto quede un poco mas abajo del subsidio
			// Por el momento no se utilizan los dos metodo juntos y solo esta activo el del texto de gasolina regular
			doc.setTextColor('black');
			doc.setFont(font, 'normal', 'normal');
			doc.setFontSize(7);

			let leftValue = x;
			let heightValue = y;

			if (template == 3 || template == 2 || template == 1) {
				leftValue -= 110;
			}

			if (template == 6) {
				heightValue += 8;
			}

			const totalWithoutSubsidy =
				Number(invoiceData.total || 0) +
				Number(invoiceData.totalSubsidy || 0);

			const text1 =
				`El 90% de la mezcla de gasolina regular incluida en este documento está afecta al IDP (Ac. Gub. 257- 2025 y Ac. Ministerial 333-2026).`;

			const maxWidth = 130;

			const lines1 = doc.splitTextToSize(text1, maxWidth);

			doc.text(lines1, leftValue, heightValue, { align });
		}
	}
*/

	// Este metodo no es de regular sino es el nuevo del idp y el iva exento
	private putRegularTextBelowTotal(
		doc: any,
		invoiceData: InvoiceTemplateModel,
		x: number,
		y: number,
		align: 'left' | 'center' | 'right' = 'right',
		font: string = 'helvetica',
		color: any = 'gray',
		template: number = 0,
	) {
		console.log("LEGO AL EXTRA", invoiceData.hasRegularExtraTax);
		if (
			(invoiceData.type == InvoiceType.NORMAL || invoiceData.type == InvoiceType.NCRE || invoiceData.type == InvoiceType.FCAM) &&
			invoiceData.hasRegularExtraTax
		) {
			console.log("ENTRO AL EXTRA");
			// NOTA: Esta parte se agrego despues del subsidio aunque se sobre pone a el, para que los dos queden en funcionamiento 
			// Habria que modificar que este texto quede un poco mas abajo del subsidio
			// Por el momento no se utilizan los dos metodo juntos y solo esta activo el del texto de gasolina regular
			doc.setTextColor('black');
			doc.setFont(font, 'normal', 'normal');
			doc.setFontSize(7);

			let leftValue = x;
			let heightValue = y;

			if (template == 3 || template == 2 || template == 1) {
				leftValue -= 110;
			}

			if (template == 6) {
				heightValue += 8;
			}

			const totalIVAExempt = Number(invoiceData.totalIVAExempt || 0);
			const totalIDPExempt = Number(invoiceData.totalIDPExempt || 0);

			const text1 =
				`Monto de exención temporal de IVA aplicada: ${this.getNumberLikeMoneyCurrency(totalIVAExempt, invoiceData.currency)} según Decreto Número 22-2026`;

			const text2 =
				`Monto de exención temporal de IDP aplicada: ${this.getNumberLikeMoneyCurrency(totalIDPExempt, invoiceData.currency)} según Decreto Número 22-2026`;

			const maxWidth = 130;

			const lines1 = doc.splitTextToSize(text1, maxWidth);
			const lines2 = doc.splitTextToSize(text2, maxWidth);

			doc.text(lines1, leftValue, heightValue, { align });

			heightValue += lines1.length * 6;

			doc.text(lines2, leftValue, heightValue, { align });
		}
	}

	private getFcamProtestText(invoiceData: InvoiceTemplateModel): string {
		const clientName = invoiceData?.client?.name || '';

		return `A 30 días de crédito, especificamos esta factura cambiaria, usted(es) pagará(n) por esta única factura cambiaria libre de protesto a la orden o endoso de ${clientName} el valor total por el que está extendida, valor recibido que asentarán ustedes a cuenta según nuestro aviso. No se considera cancelada esta factura si no está amparada por el recibo de caja extendido por la empresa, el cobrador o vendedor autorizado. El comprador da como bueno el valor de esta factura y se compromete a cancelar al vencimiento. La falta total de pago o cuotas pactadas en el lugar, modo y tiempo estipulados, dará por vencido el plazo de la obligación y el tenedor tendrá derecho para cobrar el adeudo, intereses y costas legales causadas, en la vía judicial correspondiente sirviendo como título ejecutivo esta única factura cambiaria. El comprador renuncia al fuero de su domicilio o el de cualquier otra competencia y se somete expresamente a los tribunales que el tenedor de esta factura elija, el aceptante comprador y el avalista por el carácter de factura cambiaria aceptan como buenas las condiciones de esta factura cambiaria.`;
	}

	private putFcamProtest(
		doc: any,
		invoiceData: InvoiceTemplateModel,
		x: number,
		y: number,
		maxWidth: number,
		align: 'left' | 'center' | 'right' = 'left',
		font: string = 'helvetica',
		fontSize: number = 6,
		color: any = 'black'
	): number {

		if (invoiceData.type !== InvoiceType.FCAM) {
			return y;
		}

		doc.setFont(font, 'normal', 'normal');
		doc.setFontSize(fontSize);

		const lines = doc.splitTextToSize(
			this.getFcamProtestText(invoiceData),
			maxWidth
		);

		doc.setTextColor('white');
		doc.text(lines, x + 0.4, y + 0.4, { align });

		doc.setTextColor(color);
		doc.text(lines, x, y, { align });

		return y + doc.getTextDimensions(lines).h + 4;
	}

	private addFcamProtestPage(doc: any, invoiceData: InvoiceTemplateModel, font: string = 'helvetica') {
		if (invoiceData.type !== InvoiceType.FCAM) {
			return;
		}

		doc.addPage();

		const margin = 60;
		const pageWidth = doc.internal.pageSize.width;
		const pageHeight = doc.internal.pageSize.height;

		doc.setFont(font, 'normal', 'bold');
		doc.setFontSize(14);
		doc.setTextColor('black');
		doc.text('FACTURA CAMBIARIA LIBRE DE PROTESTO', pageWidth / 2, margin, { align: 'center' });

		doc.setFont(font, 'normal', 'normal');
		doc.setFontSize(10);

		const text = this.getFcamProtestText(invoiceData);
		const lines = doc.splitTextToSize(text, pageWidth - margin * 2);

		doc.text(lines, margin, margin + 35, { align: 'left' });

		doc.setFont(font, 'normal', 'bold');
		doc.setFontSize(11);

		doc.text('ACEPTANTE / COMPRADOR', pageWidth / 2, pageHeight - 70, { align: 'center' });
		doc.line(pageWidth / 2 - 90, pageHeight - 85, pageWidth / 2 + 90, pageHeight - 85);
	}

}